/*
 * @Description:
 * @Author: PF
 * @Date: 2026-08-06 10:16:41
 * @LastEditors: PF
 * @LastEditTime: 2026-10-10 14:12:41
 */
import { actionPost } from '@/api/common.js'
import layout from '@/views/layout/index.vue'
import ziLayout from '@/views/layout/subIndex.vue'

export function loadJiaoZhiGongSelect () {
  actionPost({ url: '/api/v2/sys/menu/tree', data: {} }).then((res) => {
    if (res.code === 200) {
      return res.data.map(item => ({
        id: item.id,
        title: item.cdmc,
        path: item.cdlj,
        component: item.cdlj ? () => import(`@${item.zjlj}.vue`) : null
      }))
    }
  })
}
export const menu = [
  {
    path: '/',
    meta: { needLogin: true, keepAlive: true },
    component: () => import('@/views/home.vue')
  },

  // 教务管理系统
  {
    path: '/jiaowu',
    meta: { keepAlive: true },
    redirect: '/jiaowu/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/jiaowu/home',
        meta: { title: '教务管理系统', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jiaowuhome.vue')
      },
      // 规章制度
      {
        path: '/jiaowu/guizhangzhidu/guizhangzhiduguanli',
        meta: { title: '规章制度管理', needLogin: true, keepAlive: true },
        component: () => import('@/components/guizhangzhidu/guizhangzhiduguanli/list.vue')
      },
      // 基础设置 BEGIN
      {
        path: '/jiaowu/jichushezhi/zhuanye',
        meta: { title: '专业设置', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jichushezhi/zhuanye/list.vue')
      },
      {
        path: '/jiaowu/jichushezhi/kecheng',
        meta: { title: '课程管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jichushezhi/kecheng/list.vue')
      },
      {
        path: '/jiaowu/jichushezhi/jiaozhigong',
        meta: { title: '授课教师', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jichushezhi/jiaozhigong/list.vue')
      },
      {
        path: '/jiaowu/jichushezhi/xueqi',
        meta: { title: '学期管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jichushezhi/xueqi/list.vue')
      },
      {
        path: '/jiaowu/jichushezhi/nianji',
        meta: { title: '年级管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jichushezhi/nianji/list.vue')
      },
      {
        path: '/jiaowu/jichushezhi/jiaoxuechangdi',
        meta: { title: '教学场地', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jichushezhi/jiaoxuechangdi/list.vue')
      },
      {
        path: '/jiaowu/jichushezhi/banji',
        meta: { title: '班级基本信息', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jichushezhi/banji/list.vue')
      },
      {
        path: '/jiaowu/jichushezhi/xiaoli',
        meta: { title: '校历管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jichushezhi/xiaoli/list.vue')
      },
      {
        path: '/jiaowu/jichushezhi/rencaipeiyangmuban',
        meta: { title: '人才培养方案模板', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jichushezhi/rencaipeiyangmuban/list.vue')
      },
      {
        path: '/jiaowu/jichushezhi/tiaodaikefuzeren',
        meta: { title: '调代课负责人', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jichushezhi/tiaodaikefuzeren/list.vue')
      },
      // 基础信息 END
      // 培养方案 BEGIN
      {
        path: '/jiaowu/peiyangfangan/rencaipeiyang',
        meta: { title: '人才培养方案', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/peiyangfangan/rencaipeiyang/list.vue')
      },
      {
        path: '/jiaowu/peiyangfangan/jiaoxuejihua',
        meta: { title: '教学计划实施方案', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/peiyangfangan/jiaoxuejihua/list.vue')
      },
      {
        path: '/jiaowu/peiyangfangan/xueqikaikeanpai',
        meta: { title: '学期开课安排', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/peiyangfangan/xueqikaikeanpai/list.vue')
      },
      {
        path: '/jiaowu/peiyangfangan/xueqigongzuoliangtongji',
        meta: { title: '学期工作量统计', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/peiyangfangan/xueqigongzuoliangtongji/list.vue')
      },
      // 培养方案 END
      // 排课管理 BEGIN
      {
        path: '/jiaowu/paikeguanli/zuoxishijian',
        meta: { title: '作息时间', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/paikeguanli/zuoxishijian/list.vue')
      },
      {
        path: '/jiaowu/paikeguanli/kebiaojiegou',
        meta: { title: '课表结构', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/paikeguanli/kebiaojiegou/list.vue')
      },
      {
        path: '/jiaowu/paikeguanli/paiketianjian',
        meta: { title: '排课条件', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/paikeguanli/paiketianjian/list.vue')
      },
      {
        path: '/jiaowu/paikeguanli/paikerenwu',
        meta: { title: '排课任务', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/paikeguanli/paikerenwu/list.vue')
      },
      {
        path: '/jiaowu/paikeguanli/xiaolikebiao',
        meta: { title: '校历课表', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/paikeguanli/xiaolikebiao/list.vue')
      },
      {
        path: '/jiaowu/paikeguanli/tiaokeguanli',
        meta: { title: '调课管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/paikeguanli/tiaokeguanli/list.vue')
      },
      // 排课管理 END
      // 选修课管理 BEGIN
      {
        path: '/jiaowu/paikeguanli/renyixuanxiuke',
        meta: { title: '任意选修课', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/paikeguanli/renyixuanxiuke/list.vue')
      },
      {
        path: '/jiaowu/paikeguanli/xiandingxuanxiuke',
        meta: { title: '限定选修课', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/paikeguanli/xiandingxuanxiuke/list.vue')
      },
      {
        path: '/jiaowu/paikeguanli/xueshengxuankechaxun',
        meta: { title: '学生选课查询', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/paikeguanli/xueshengxuankechaxun/list.vue')
      },
      {
        path: '/jiaowu/paikeguanli/xuankejieguochaxun',
        meta: { title: '选课结果查询', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/paikeguanli/xuankejieguochaxun/list.vue')
      },
      {
        path: '/jiaowu/paikeguanli/xuanxiukekaibanguanli',
        meta: { title: '选修课开班管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/paikeguanli/xuanxiukekaibanguanli/list.vue')
      },
      {
        path: '/jiaowu/xuanxiukeguanli/xuanxiukekaibanchaxun',
        meta: { title: '选修课开班查询', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/xuanxiukeguanli/xuanxiukekaibanchaxun/list.vue')
      },
      {
        path: '/jiaowu/xuanxiukeguanli/xuanxiukepaike',
        meta: { title: '选修课排课', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/xuanxiukeguanli/xuanxiukepaike/list.vue')
      },
      // 选修课管理 END
      // 课时管理 BEGIN
      {
        path: '/jiaowu/keshiguanli/keshifenzu',
        meta: { title: '课时分组', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/keshiguanli/keshifenzu/list.vue')
      },
      {
        path: '/jiaowu/keshiguanli/keshiluru',
        meta: { title: '课时录入', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/keshiguanli/keshiluru/list.vue')
      },
      {
        path: '/jiaowu/keshiguanli/keshiguanli',
        meta: { title: '课时管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/keshiguanli/keshiguanli/list.vue')
      },
      {
        path: '/jiaowu/keshiguanli/keshitongji',
        meta: { title: '课时统计', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/keshiguanli/keshitongji/list.vue')
      },
      // 课时管理 END
      // 学籍管理 BEGIN
      {
        path: '/jiaowu/xuejiguanli/xuejijibenxinxi',
        meta: { title: '学籍基本信息', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/xveshengxinxi/xueshengjibenxinxi/list.vue')
      },
      {
        path: '/jiaowu/xuejiguanli/xuejiyidong',
        meta: { title: '学籍异动', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/xuejiguanli/xuejiyidong/list.vue')
      },
      {
        path: '/jiaowu/xuejiguanli/xueqibaodao',
        meta: { title: '学期报道', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/xuejiguanli/xueqibaodao/list.vue')
      },
      // 学籍管理 END
      // 毕业管理 BEGIN
      {
        path: '/jiaowu/biyeguanli/shezhibiyetiaojian',
        meta: { title: '设置毕业条件', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/biyeguanli/shezhibiyetiaojian/list.vue')
      },

      {
        path: '/jiaowu/biyeguanli/biye',
        meta: { title: '毕业管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/biyeguanli/biye/list.vue')
      },
      {
        path: '/jiaowu/biyeguanli/biyezhengshufangfa',
        meta: { title: '毕业证书发放记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/biyeguanli/biyezhengshufangfa/list.vue')
      },
      {
        path: '/jiaowu/biyeguanli/yujingzhibiao',
        meta: { title: '毕业预警指标', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/biyeguanli/yujingzhibiao/list.vue')
      },
      {
        path: '/jiaowu/biyeguanli/biyeyujing',
        meta: { title: '毕业预警', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/biyeguanli/biyeyujing/list.vue')
      },
      // 毕业管理 END
      // 证书管理 BEGIN
      {
        path: '/jiaowu/jichushezhi/zhengshu',
        meta: { title: '证书', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jichushezhi/zhengshu/list.vue')
      },
      {
        path: '/jiaowu/zhengshuguanli/zhengshufafang',
        meta: { title: '证书发放', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/zhengshuguanli/zhengshufafang/list.vue')
      },
      // 证书管理 ENDN
      // 毕业证书管理 ENDN
      {
        path: '/jiaowu/biyezhengshuguanli/biyezhengdayinmuban',
        meta: { title: '毕业证打印模板', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/biyezhengshuguanli/biyezhengdayinmuban/list.vue')
      },
      {
        path: '/jiaowu/biyezhengshuguanli/biyezhengdayin',
        meta: { title: '毕业证打印', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/biyezhengshuguanli/biyezhengdayin/list.vue')
      },
      {
        path: '/jiaowu/biyezhengshuguanli/biyezhengdayinjilu',
        meta: { title: '毕业证打印记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/biyezhengshuguanli/biyezhengdayinjilu/list.vue')
      },
      {
        path: '/jiaowu/biyezhengshuguanli/zhengshufafangchaxun',
        meta: { title: '证书发放查询', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/biyezhengshuguanli/zhengshufafangchaxun/list.vue')
      },
      {
        path: '/jiaowu/biyezhengshuguanli/biyezhengmingshuguanli',
        meta: { title: '毕业证明书管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/biyezhengshuguanli/biyezhengmingshuguanli/list.vue')
      },
      // 毕业证书管理 END
      // 教材管理 BEGIN
      {
        path: '/jiaowu/jiaocaiguanli/jiaocaileibie',
        meta: { title: '教材类别', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jiaocaiguanli/jiaocaileibie/list.vue')
      },
      {
        path: '/jiaowu/jiaocaiguanli/cunfangweizhi',
        meta: { title: '存放位置', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jiaocaiguanli/cunfangweizhi/list.vue')
      },
      {
        path: '/jiaowu/jiaocaiguanli/gongyingshang',
        meta: { title: '供应商管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jiaocaiguanli/gongyingshang/list.vue')
      },
      {
        path: '/jiaowu/jiaocaiguanli/jiaocai',
        meta: { title: '教材管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jiaocaiguanli/jiaocai/list.vue')
      },
      {
        path: '/jiaowu/jiaocaiguanli/caigoujihua',
        meta: { title: '采购计划', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jiaocaiguanli/caigoujihua/list.vue')
      },
      {
        path: '/jiaowu/jiaocaiguanli/jiaocairuku',
        meta: { title: '教材入库', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jiaocaiguanli/jiaocairuku/list.vue')
      },
      {
        path: '/jiaowu/jiaocaiguanli/banjifafang',
        meta: { title: '班级发放', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jiaocaiguanli/banjifafang/list.vue')
      },
      {
        path: '/jiaowu/jiaocaiguanli/xueshenggerenlingqu',
        meta: { title: '学生个人领取', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jiaocaiguanli/xueshenggerenlingqu/list.vue')
      },
      {
        path: '/jiaowu/jiaocaiguanli/jiaoshilingqu',
        meta: { title: '教师领取', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jiaocaiguanli/jiaoshilingqu/list.vue')
      },
      {
        path: '/jiaowu/jiaocaiguanli/jiaocaibaofei',
        meta: { title: '教材报废', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jiaocaiguanli/jiaocaibaofei/list.vue')
      }
      // 教材管理 END
    ]
  },
  // 教学管理系统
  {
    path: '/jiaoxue',
    meta: { keepAlive: true },
    redirect: '/jiaoxue/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/jiaoxue/home',
        meta: { title: '教学管理系统', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jiaoxuehome.vue')
      },
      // 规章制度
      {
        path: '/jiaoxue/guizhangzhidu/guizhangzhiduguanli',
        meta: { title: '规章制度管理', needLogin: true, keepAlive: true },
        component: () => import('@/components/guizhangzhidu/guizhangzhiduguanli/list.vue')
      },
      // 基础设置
      {
        path: '/jiaoxue/jichushezhi/tingkejilumuban',
        meta: { title: '听课记录模板', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jichushezhi/tingkejilumuban/list.vue')
      },
      {
        path: '/jiaoxue/jichushezhi/jiaoxuerizhimuban',
        meta: { title: '教学日志模板', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jichushezhi/jiaoxuerizhimuban/list.vue')
      },
      {
        path: '/jiaoxue/jichushezhi/jiaoxuerizhikechengyaoqiuwanchengshijian',
        meta: { title: '教学日志课程要求完成时间', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jichushezhi/jiaoxuerizhikechengyaoqiuwanchengshijian/list.vue')
      },
      {
        path: '/jiaoxue/jichushezhi/xueshengpingjiaomuban',
        meta: { title: '学生评教模板', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jichushezhi/xueshengpingjiaomuban/list.vue')
      },
      {
        path: '/jiaoxue/jichushezhi/beikemuban',
        meta: { title: '备课模板', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jichushezhi/beikemuban/list.vue')
      },
      {
        path: '/jiaoxue/jichushezhi/jiaoxueshejimuban',
        meta: { title: '教学设计模板', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jichushezhi/jiaoxueshejimuban/list.vue')
      },
      {
        path: '/jiaoxue/jichushezhi/kaoqinjilumuban',
        meta: { title: '考勤纪律模板', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jichushezhi/kaoqinjilumuban/list.vue')
      },
      {
        path: '/jiaoxue/jichushezhi/jiaoanzhishiku',
        meta: { title: '教案知识库', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jichushezhi/jiaoanzhishiku/list.vue')
      },
      // 考务管理 BEGIN
      {
        path: '/jiaoxue/kaowuguanli/fenzhi',
        meta: { title: '分制管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/kaowuguanli/fenzhi/list.vue')
      },
      {
        path: '/jiaoxue/kaowuguanli/mianxiu',
        meta: { title: '免修管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/kaowuguanli/mianxiu/list.vue')
      },
      {
        path: '/jiaoxue/kaowuguanli/miankao',
        meta: { title: '免考管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/kaowuguanli/miankao/list.vue')
      },
      {
        path: '/jiaoxue/kaowuguanli/kaoshikemu',
        meta: { title: '考试科目管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/kaowuguanli/kaoshikemu/list.vue')
      },
      {
        path: '/jiaoxue/kaowuguanli/kaoshijihua',
        meta: { title: '考试计划管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/kaowuguanli/kaoshijihua/list.vue')
      },
      {
        path: '/jiaoxue/kaowuguanli/paikaoguanli',
        meta: { title: '排考管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/kaowuguanli/paikaoguanli/list.vue')
      },
      {
        path: '/jiaoxue/kaowuguanli/kaoshianpaichakan',
        meta: { title: '考试安排查看', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/kaowuguanli/kaoshianpaichakan/list.vue')
      },
      {
        path: '/jiaoxue/kaowuguanli/bukao',
        meta: { title: '补考管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/kaowuguanli/bukao/list.vue')
      },
      // 考务管理 END
      // 成绩学分管理 BEGIN
      {
        path: '/jiaoxue/chengjixuefenguanli/zongpingchengjizucheng',
        meta: { title: '总评成绩组成', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/chengjixuefenguanli/zongpingchengjizucheng/list.vue')
      },
      {
        path: '/jiaoxue/chengjixuefenguanli/kaoshi',
        meta: { title: '考试管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/chengjixuefenguanli/kaoshi/list.vue')
      },
      {
        path: '/jiaoxue/chengjixuefenguanli/kaoshichengjiluru',
        meta: { title: '考试成绩录入', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/chengjixuefenguanli/kaoshichengjiluru/list.vue')
      },
      {
        path: '/jiaoxue/chengjixuefenguanli/pingshichengjiluru',
        meta: { title: '平时成绩成绩录入', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/chengjixuefenguanli/pingshichengjiluru/list.vue')
      },
      {
        path: '/jiaoxue/chengjixuefenguanli/bukaochengjiluru',
        meta: { title: '补考成绩录入', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/chengjixuefenguanli/bukaochengjiluru/list.vue')
      },
      {
        path: '/jiaoxue/chengjixuefenguanli/kaoshichengjishenhe',
        meta: { title: '考试成绩审核', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/chengjixuefenguanli/kaoshichengjishenhe/list.vue')
      },
      {
        path: '/jiaoxue/chengjixuefenguanli/pingshichengjishenhe',
        meta: { title: '平时成绩成绩审核', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/chengjixuefenguanli/pingshichengjishenhe/list.vue')
      },
      {
        path: '/jiaoxue/chengjixuefenguanli/bukaochengjishenhe',
        meta: { title: '补考成绩审核', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/chengjixuefenguanli/bukaochengjishenhe/list.vue')
      },
      {
        path: '/jiaoxue/chengjixuefenguanli/chengji',
        meta: { title: '成绩管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/chengjixuefenguanli/chengji/list.vue')
      },
      {
        path: '/jiaoxue/chengjixuefenguanli/zongpingchengji',
        meta: { title: '总评成绩管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/chengjixuefenguanli/zongpingchengji/list.vue')
      },
      {
        path: '/jiaoxue/chengjixuefenguanli/dankechengji',
        meta: { title: '单科成绩查询', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/chengjixuefenguanli/dankechengji/list.vue')
      },
      {
        path: '/jiaoxue/chengjixuefenguanli/banjichengji',
        meta: { title: '班级成绩查询', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/chengjixuefenguanli/banjichengji/list.vue')
      },
      {
        path: '/jiaoxue/chengjixuefenguanli/xuefenjiangcheng',
        meta: { title: '学分奖惩', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/chengjixuefenguanli/xuefenjiangcheng/list.vue')
      },
      {
        path: '/jiaoxue/chengjixuefenguanli/xuefenrizhi',
        meta: { title: '学分日志', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/chengjixuefenguanli/xuefenrizhi/list.vue')
      },
      {
        path: '/jiaoxue/chengjixuefenguanli/xuefenhuizong',
        meta: { title: '学分汇总', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/chengjixuefenguanli/xuefenhuizong/list.vue')
      },
      {
        path: '/jiaoxue/chengjixuefenguanli/chengjitongjifenxi',
        meta: { title: '成绩统计分析', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/chengjixuefenguanli/chengjitongjifenxi/list.vue')
      },
      {
        path: '/jiaoxue/chengjixuefenguanli/biyechengjiguanli',
        meta: { title: '毕业成绩管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/chengjixuefenguanli/biyechengjiguanli/list.vue')
      },
      {
        path: '/jiaoxue/chengjixuefenguanli/zonghechengjiyupingjia',
        meta: { title: '综合成绩与评价', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/chengjixuefenguanli/zonghechengjiyupingjia/list.vue')
      },
      // 成绩学分管理 END

      // 教学督导 BEGIN
      {
        path: '/jiaoxue/jiaoxuedudao/jiaoxuejindu',
        meta: { title: '教学进度', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jiaoxuedudao/jiaoxuejindu/list.vue')
      },
      {
        path: '/jiaoxue/jiaoxuedudao/tingkecelve',
        meta: { title: '听课策略管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jiaoxuedudao/tingkecelve/list.vue')
      },
      {
        path: '/jiaoxue/jiaoxuedudao/tingkerenwu',
        meta: { title: '听课任务', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jiaoxuedudao/tingkerenwu/list.vue')
      },
      {
        path: '/jiaoxue/jiaoxuedudao/tingkejilu',
        meta: { title: '听课记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jiaoxuedudao/tingkejilu/list.vue')
      },
      {
        path: '/jiaoxue/jiaoxuedudao/zuoyeshenhe',
        meta: { title: '作业审核', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jiaoxuedudao/zuoyeshenhe/list.vue')
      },
      {
        path: '/jiaoxue/zuoyeguanli/jiaoshizuoye',
        meta: { title: '教师布置作业', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/zuoyeguanli/jiaoshizuoye/list.vue')
      },
      {
        path: '/jiaoxue/zuoyeguanli/xueshengzuoye',
        meta: { title: '学生作业', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/zuoyeguanli/xueshengzuoye/list.vue')
      },
      {
        path: '/jiaoxue/jiaoxuedudao/wodejiaoxuesheji',
        meta: { title: '我的教学设计', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jiaoxuedudao/wodejiaoxuesheji/list.vue')
      },
      {
        path: '/jiaoxue/jiaoxuedudao/jiaoxveshejishenhe',
        meta: { title: '教学设计审核', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jiaoxuedudao/jiaoxveshejishenhe/list.vue')
      },
      {
        path: '/jiaoxue/jiaoxuedudao/qingjiajilu',
        meta: { title: '请假记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jiaoxuedudao/qingjiajilu/list.vue')
      },
      {
        path: '/jiaoxue/jiaoxuedudao/jiaoxvesheji',
        meta: { title: '教学设计管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jiaoxuedudao/jiaoxvesheji/list.vue')
      },
      {
        path: '/jiaoxue/jiaoxuedudao/xveshengkaoqin',
        meta: { title: '学生考勤', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jiaoxuedudao/xveshengkaoqin/list.vue')
      },
      {
        path: '/jiaoxue/jiaoxuedudao/jiaoxuerizhijilu',
        meta: { title: '教学日志记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jiaoxuedudao/jiaoxuerizhijilu/list.vue')
      },
      {
        path: '/jiaoxue/jiaoxuedudao/jiaoxuerizhisc',
        meta: { title: '教学日志上传情况', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jiaoxuedudao/jiaoxuerizhisc/list.vue')
      },
      {
        path: '/jiaoxue/jiaoxuedudao/jiaoxuegongzuozu',
        meta: { title: '教学工作组', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jiaoxuedudao/jiaoxuegongzuozu/list.vue')
      },
      {
        path: '/jiaoxue/jiaoxuedudao/jiaoxuegongzuoyaoqiu',
        meta: { title: '教学工作要求', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jiaoxuedudao/jiaoxuegongzuoyaoqiu/list.vue')
      },
      {
        path: '/jiaoxue/jiaoxuedudao/jiaoxuejiancha',
        meta: { title: '教学工作检查记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jiaoxuedudao/jiaoxuejiancha/list.vue')
      },
      {
        path: '/jiaoxue/jiaoxuedudao/jiaoxuegongzuoshijianyaoqiu',
        meta: { title: '教学工作时间要求', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jiaoxuedudao/jiaoxuegongzuoshijianyaoqiu/list.vue')
      },
      {
        path: '/jiaoxue/jiaoxuedudao/ketanghudong',
        meta: { title: '课堂互动', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jiaoxuedudao/ketanghudong/list.vue')
      },
      {
        path: '/jiaoxue/jiaoxuedudao/xunkeguanli',
        meta: { title: '巡课管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jiaoxuedudao/xunkeguanli/list.vue')
      },
      {
        path: '/jiaoxue/jiaoxuedudao/jiaoanguanli',
        meta: { title: '教案管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jiaoxuedudao/jiaoanguanli/list.vue')
      },
      // 教学督导 END
      // 教学评价 BEGIN
      {
        path: '/jiaoxue/jiaoxuepingjia/xueshengpingjiao',
        meta: { title: '教学评教', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoxue/jiaoxuepingjia/xueshengpingjiao/list.vue')
      }
      // 教学评价 END
    ]
  },
  // 实训教学管理服务
  {
    path: '/shixunjiaoxue',
    meta: { keepAlive: true },
    redirect: '/shixunjiaoxue/home',
    component: ziLayout,
    children: [
      {
        path: '/shixunjiaoxue/home',
        meta: { title: '实训教学管理服务', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shixunjiaoxue/shixunjiaoxuehome.vue')
      },
      // 基础设置
      {
        path: '/shixunjiaoxue/guizhangzhidu/guizhangzhiduguanli',
        meta: { title: '规章制度管理', needLogin: true, keepAlive: true },
        component: () => import('@/components/guizhangzhidu/guizhangzhiduguanli/list.vue')
      },
      // 实习基地 BEGIN
      {
        path: '/shixunjiaoxue/shixijidi/xiaoneishixijidi',
        meta: { title: '校内实习基地', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shixunjiaoxue/shixijidi/xiaoneishixijidi/list.vue')
      },
      {
        path: '/shixunjiaoxue/shixijidi/xiaowaishixijidi',
        meta: { title: '校外实习基地', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shixunjiaoxue/shixijidi/xiaowaishixijidi/list.vue')
      },
      // 实习基地 END
      {
        path: '/shixunjiaoxue/shixiqingkuang/xueshengxiaowaishixiqingkuang',
        meta: { title: '学生校外实习情况', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shixunjiaoxue/shixiqingkuang/xueshengxiaowaishixiqingkuang/list.vue')
      },
      {
        path: '/shixunjiaoxue/shixunjiaoxue/jiaoxueguocheng',
        meta: { title: '实训教学过程', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shixunjiaoxue/shixunjiaoxue/jiaoxueguocheng/list.vue')
      }
    ]
  },
  // 教师教学质量综合考核系统
  {
    path: '/jiaoshikaohe',
    meta: { keepAlive: true },
    redirect: '/jiaoshikaohe/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/jiaoshikaohe/home',
        meta: { title: '教师教学质量综合考核系统', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoshikaohe/jiaoshikaohehome.vue')
      },
      // 基础设置
      {
        path: '/jiaoshikaohe/jichushezhi/kaohefenlei',
        meta: { title: '考核分类', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoshikaohe/jichushezhi/kaohefenlei/list.vue')
      },
      {
        path: '/jiaoshikaohe/jichushezhi/fenzhidengji',
        meta: { title: '分值等级', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoshikaohe/jichushezhi/fenzhidengji/list.vue')
      },
      // 考核内容
      {
        path: '/jiaoshikaohe/kaoheneirong/kaoheleibie',
        meta: { title: '考核类别', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoshikaohe/kaoheneirong/kaoheleibie/list.vue')
      },
      {
        path: '/jiaoshikaohe/kaoheneirong/kaoheneirong',
        meta: { title: '考核内容', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoshikaohe/kaoheneirong/kaoheneirong/list.vue')
      },
      // 模板管理
      {
        path: '/jiaoshikaohe/mubanguanli/kaohemuban',
        meta: { title: '模板管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoshikaohe/mubanguanli/kaohemuban/list.vue')
      },
      // 免评教师管理
      {
        path: '/jiaoshikaohe/mianpingjiaoshiguanli/mianpingjiaoshi',
        meta: { title: '免评教师', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoshikaohe/mianpingjiaoshiguanli/mianpingjiaoshi/list.vue')
      },
      // 考核项目管理
      {
        path: '/jiaoshikaohe/kaohexiangmuguanli/kaohexiangmu',
        meta: { title: '考核项目', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoshikaohe/kaohexiangmuguanli/kaohexiangmu/list.vue')
      },
      // 考核报告管理
      {
        path: '/jiaoshikaohe/kaohebaogaoguanli/kaohebaogao',
        meta: { title: '考核报告', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoshikaohe/kaohebaogaoguanli/kaohebaogao/list.vue')
      },
      {
        path: '/jiaoshikaohe/kaohebaogaoguanli/xueniankaohebaogao',
        meta: { title: '学年考核报告', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaoshikaohe/kaohebaogaoguanli/xueniankaohebaogao/list.vue')
      }
    ]
  },
  // 招生管理系统
  {
    path: '/zhaosheng',
    meta: { keepAlive: true },
    redirect: '/zhaosheng/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/zhaosheng/home',
        meta: { title: '招生管理系统', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zhaosheng/zhaoshenghome.vue')
      },
      // 规章制度
      {
        path: '/zhaosheng/guizhangzhidu/guizhangzhiduguanli',
        meta: { title: '规章制度管理', needLogin: true, keepAlive: true },
        component: () => import('@/components/guizhangzhidu/guizhangzhiduguanli/list.vue')
      },
      // 基础设置
      {
        path: '/zhaosheng/jichushezhi/zhaoshengzu',
        meta: { title: '招生组管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zhaosheng/jichushezhi/zhaoshengzu/list.vue')
      },

      {
        path: '/zhaosheng/jichushezhi/zhaoshengjihua',
        meta: { title: '招生计划', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zhaosheng/jichushezhi/zhaoshengjihua/list.vue')
      },
      {
        path: '/zhaosheng/jichushezhi/zhaoshengquyu',
        meta: { title: '招生区域', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zhaosheng/jichushezhi/zhaoshengquyu/list.vue')
      },
      {
        path: '/zhaosheng/jichushezhi/baomingqudao',
        meta: { title: '报名渠道', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zhaosheng/jichushezhi/baomingqudao/list.vue')
      },
      {
        path: '/zhaosheng/ruxue/xinsheng',
        meta: { title: '新生管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zhaosheng/ruxue/xinsheng/list.vue')
      },
      {
        path: '/zhaosheng/ruxue/xinshengluqu',
        meta: { title: '新生录取', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zhaosheng/ruxue/xinshengluqu/list.vue')
      },
      {
        path: '/zhaosheng/ruxue/xinshengbaoming',
        meta: { title: '新生报名', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zhaosheng/ruxue/xinshengbaoming/list.vue')
      },
      {
        path: '/zhaosheng/ruxue/xinshengfenban',
        meta: { title: '新生分班', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zhaosheng/ruxue/xinshengfenban/list.vue')
      },
      {
        path: '/zhaosheng/ruxue/xinshengliushi',
        meta: { title: '流失管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zhaosheng/ruxue/xinshengliushi/list.vue')
      },
      {
        path: '/zhaosheng/ruxue/xinshengxuejizuce',
        meta: { title: '注册管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zhaosheng/ruxue/xinshengxuejizuce/list.vue')
      },
      {
        path: '/zhaosheng/jichushezhi/rencaipeiyangmuban',
        meta: { title: '人才培养方案模板', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jichushezhi/rencaipeiyangmuban/list.vue')
      },
      {
        path: '/zhaosheng/peiyangfangan/rencaipeiyang',
        meta: { title: '人才培养方案', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/peiyangfangan/rencaipeiyang/list.vue')
      },
      {
        path: '/zhaosheng/peiyangfangan/jiaoxuejihua',
        meta: { title: '教学计划实施方案', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/peiyangfangan/jiaoxuejihua/list.vue')
      },
      // 基础设置 BEGIN
      {
        path: '/zhaosheng/jichushezhi/zhuanye',
        meta: { title: '专业设置', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jichushezhi/zhuanye/list.vue')
      },
      {
        path: '/zhaosheng/jichushezhi/kecheng',
        meta: { title: '课程管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jichushezhi/kecheng/list.vue')
      },
      {
        path: '/zhaosheng/jichushezhi/jiaozhigong',
        meta: { title: '授课教师', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jichushezhi/jiaozhigong/list.vue')
      },
      {
        path: '/zhaosheng/jichushezhi/xueqi',
        meta: { title: '学期管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jichushezhi/xueqi/list.vue')
      },
      {
        path: '/zhaosheng/jichushezhi/nianji',
        meta: { title: '年级管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jichushezhi/nianji/list.vue')
      },
      {
        path: '/zhaosheng/jichushezhi/jiaoxuechangdi',
        meta: { title: '教学场地', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jichushezhi/jiaoxuechangdi/list.vue')
      },
      {
        path: '/zhaosheng/jichushezhi/banji',
        meta: { title: '班级基本信息', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jichushezhi/banji/list.vue')
      },
      {
        path: '/zhaosheng/jichushezhi/xiaoli',
        meta: { title: '校历管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jichushezhi/xiaoli/list.vue')
      },
      {
        path: '/zhaosheng/jichushezhi/tiaodaikefuzeren',
        meta: { title: '调代课负责人', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaowu/jichushezhi/tiaodaikefuzeren/list.vue')
      }
      // 基础信息 END
    ]
  },
  // 学生管理系统
  {
    path: '/xuesheng',
    meta: { keepAlive: true },
    redirect: '/xuesheng/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/xuesheng/home',
        meta: { title: '学生管理系统', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/xueshenghome.vue')
      },
      // 规章制度
      {
        path: '/xuesheng/guizhangzhidu/guizhangzhiduguanli',
        meta: { title: '规章制度管理', needLogin: true, keepAlive: true },
        component: () => import('@/components/guizhangzhidu/guizhangzhiduguanli/list.vue')
      },
      // 基础信息
      {
        path: '/xuesheng/jichuxinxi/pingjiamuban',
        meta: { title: '评价模板', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/jichuxinxi/pingjiamuban/list.vue')
      },
      // 学生信息查询
      {
        path: '/xuesheng/xveshengxinxi/xueshengjibenxinxi',
        meta: { title: '学生基本信息', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/xveshengxinxi/xueshengjibenxinxi/list.vue')
      },
      {
        path: '/xuesheng/xveshengxinxi/xueshenglixiaoguanli',
        meta: { title: '学生离校管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/xveshengxinxi/xueshenglixiaoguanli/list.vue')
      },
      {
        path: '/xuesheng/xveshengxinxi/xveshenghuaxiang',
        meta: { title: '学生画像', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/xveshengxinxi/xveshenghuaxiang/list.vue')
      },
      {
        path: '/xuesheng/xveshengxinxi/xveshengxiaofei',
        meta: { title: '学生消费', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/xveshengxinxi/xveshengxiaofei/list.vue')
      },
      {
        path: '/xuesheng/xveshengxinxi/xiaoneixveshengsaishi',
        meta: { title: '校内学生赛事活动', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/xveshengxinxi/xiaoneixveshengsaishi/list.vue')
      },
      // 学生奖惩
      {
        path: '/xuesheng/xueshengjiangcheng/xueshengjiangli',
        meta: { title: '学生奖励', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/xueshengjiangcheng/xueshengjiangli/list.vue')
      },
      {
        path: '/xuesheng/xueshengjiangcheng/xueshengchengchu',
        meta: { title: '学生惩处', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/xueshengjiangcheng/xueshengchengchu/list.vue')
      },
      // 奖助贷管理
      {
        path: '/xuesheng/jiangzhudai/jiangxvejin',
        meta: { title: '奖学金管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/jiangzhudai/jiangxvejin/list.vue')
      },
      {
        path: '/xuesheng/jiangzhudai/zhuxvejin',
        meta: { title: '助学金管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/jiangzhudai/zhuxvejin/list.vue')
      },
      {
        path: '/xuesheng/jiangzhudai/zhuxuedaikuan',
        meta: { title: '助学贷款管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/jiangzhudai/zhuxuedaikuan/list.vue')
      },
      {
        path: '/xuesheng/jiangzhudai/linshikunnan',
        meta: { title: '临时困难补助', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/jiangzhudai/linshikunnan/list.vue')
      },
      // 德育管理
      {
        path: '/xuesheng/xueshengdeyuguanli/fenzhishezhi',
        meta: { title: '分值设置', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/jichuxinxi/fenzhishezhi/list.vue')
      },
      {
        path: '/xuesheng/xueshengdeyuguanli/jifendengji',
        meta: { title: '积分等级', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/jichuxinxi/jifendengji/list.vue')
      },
      // 德育管理
      {
        path: '/xuesheng/xueshengdeyuguanli/xinlijiankangjaoyu',
        meta: { title: '心理健康教育', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/deyuguanli/xinlijiankangjaoyu/list.vue')
      },
      {
        path: '/xuesheng/xueshengdeyuguanli/anquanjiaoyu',
        meta: { title: '安全教育', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/deyuguanli/anquanjiaoyu/list.vue')
      },
      {
        path: '/xuesheng/xueshengdeyuguanli/jiaxiaolianxijilu',
        meta: { title: '家校联系记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/deyuguanli/jiaxiaolianxijilu/list.vue')
      },
      {
        path: '/xuesheng/xueshengdeyuguanli/gebiejiaoyujilu',
        meta: { title: '个别教育记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/deyuguanli/gebiejiaoyujilu/list.vue')
      },
      {
        path: '/xuesheng/xueshengdeyuguanli/xueshengxuepipingyu',
        meta: { title: '学生学期评语', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/deyuguanli/xueshengxuepipingyu/list.vue')
      },
      {
        path: '/xuesheng/xueshengdeyuguanli/xueshengzaixiaolvli',
        meta: { title: '学生在校履历', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/deyuguanli/xueshengzaixiaolvli/list.vue')
      },
      {
        path: '/xuesheng/xueshengdeyuguanli/deyuhuodong',
        meta: { title: '德育活动', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/deyuguanli/deyuhuodong/list.vue')
      },
      {
        path: '/xuesheng/xueshengdeyuguanli/shehuishijianhuodong',
        meta: { title: '社会实践活动', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/deyuguanli/shehuishijianhuodong/list.vue')
      },
      {
        path: '/xuesheng/xueshengdeyuguanli/pingjiaguanli',
        meta: { title: '评价管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/deyuguanli/pingjiaguanli/list.vue')
      },
      {
        path: '/xuesheng/xueshengdeyuguanli/xueshengpingjiahuizong',
        meta: { title: '学生评价汇总', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/deyuguanli/xueshengpingjiahuizong/list.vue')
      },
      {
        path: '/xuesheng/xueshengdeyuguanli/deyufenhuizong',
        meta: { title: '德育分汇总', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/deyuguanli/deyufenhuizong/list.vue')
      },
      // 班级信息查询
      {
        path: '/xuesheng/banjixinxichaxun/banjixinxi',
        meta: { title: '班级信息', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/banjixinxichaxun/banjixinxi/list.vue')
      },
      {
        path: '/xuesheng/banjixinxichaxun/banjichengyuan',
        meta: { title: '班级成员', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/banjixinxichaxun/banjichengyuan/list.vue')
      },
      {
        path: '/xuesheng/banjixinxichaxun/banjikebiao',
        meta: { title: '班级课表', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/banjixinxichaxun/banjikebiao/list.vue')
      },
      {
        path: '/xuesheng/banjixinxichaxun/banjichengji',
        meta: { title: '班级成绩', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/banjixinxichaxun/banjichengji/list.vue')
      },
      {
        path: '/xuesheng/banjixinxichaxun/xueshengjiangli',
        meta: { title: '学生奖励', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/banjixinxichaxun/xueshengjiangli/list.vue')
      },
      {
        path: '/xuesheng/banjixinxichaxun/xueshengchufa',
        meta: { title: '学生处罚', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/banjixinxichaxun/xueshengchufa/list.vue')
      },
      {
        path: '/xuesheng/banjixinxichaxun/xueshengzizhuchaxun',
        meta: { title: '学生资助查询', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/banjixinxichaxun/xueshengzizhuchaxun/list.vue')
      },
      // 班级事务管理
      {
        path: '/xuesheng/banjishiwuguanli/xueshengkaoqin',
        meta: { title: '学生考勤', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/banjishiwuguanli/xueshengkaoqin/list.vue')
      },
      {
        path: '/xuesheng/banjishiwuguanli/xueshengqingjia',
        meta: { title: '学生请假', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/banjishiwuguanli/xueshengqingjia/list.vue')
      },
      {
        path: '/xuesheng/banjishiwuguanli/shixijiuyejilu',
        meta: { title: '实习就业记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/banjishiwuguanli/shixijiuyejilu/list.vue')
      },
      {
        path: '/xuesheng/banjishiwuguanli/banjigonggao',
        meta: { title: '班级公告', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/banjishiwuguanli/banjigonggao/list.vue')
      },
      {
        path: '/xuesheng/banjishiwuguanli/xueshengliusuguanli',
        meta: { title: '学生留宿管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/banjishiwuguanli/xueshengliusuguanli/list.vue')
      },
      {
        path: '/xuesheng/banjishiwuguanli/xuejiyidong',
        meta: { title: '学籍异动', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/banjishiwuguanli/xuejiyidong/list.vue')
      },
      {
        path: '/xuesheng/banjishiwuguanli/banzhurendaixuan',
        meta: { title: '班主任代选', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/banjishiwuguanli/banzhurendaixuan/list.vue')
      },
      {
        path: '/xuesheng/banjishiwuguanli/chaibanke',
        meta: { title: '拆班课', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/banjishiwuguanli/chaibanke/list.vue')
      },
      {
        path: '/xuesheng/banjishiwujilu/banjizhutibanhui',
        meta: { title: '班级主题班会', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/banjishiwujilu/banjizhutibanhui/list.vue')
      },
      {
        path: '/xuesheng/banjishiwujilu/banganwuhuiyijilu',
        meta: { title: '班干部会议记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/banjishiwujilu/banganwuhuiyijilu/list.vue')
      },

      {
        path: '/xuesheng/banjishiwujilu/banjizhongdahuodong',
        meta: { title: '班级重大活动', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/banjishiwujilu/banjizhongdahuodong/list.vue')
      },
      // 奖助贷管理
      {
        path: '/xuesheng/jiangzhudai/jiangxvejin',
        meta: { title: '奖学金管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/jiangzhudai/jiangxvejin/list.vue')
      },
      {
        path: '/xuesheng/jiangzhudai/zhuxvejin',
        meta: { title: '助学金管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/jiangzhudai/zhuxvejin/list.vue')
      },
      {
        path: '/xuesheng/jiangzhudai/zhuxuedaikuan',
        meta: { title: '助学贷款管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/jiangzhudai/zhuxuedaikuan/list.vue')
      },
      {
        path: '/xuesheng/jiangzhudai/linshikunnan',
        meta: { title: '临时困难补助', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/jiangzhudai/linshikunnan/list.vue')
      }

    ]
  },
  // 德育管理系统
  {
    path: '/deyu',
    meta: { keepAlive: true },
    redirect: '/deyu/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/deyu/home',
        meta: { title: '德育管理系统', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/deyuhome.vue')
      },
      // 规章制度
      {
        path: '/deyu/guizhangzhidu/guizhangzhiduguanli',
        meta: { title: '规章制度管理', needLogin: true, keepAlive: true },
        component: () => import('@/components/guizhangzhidu/guizhangzhiduguanli/list.vue')
      },
      // 基础信息
      {
        path: '/deyu/jichuxinxi/pingjiamuban',
        meta: { title: '评价模板', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/jichuxinxi/pingjiamuban/list.vue')
      },
      {
        path: '/deyu/jichuxinxi/fenzhishezhi',
        meta: { title: '分值设置', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/jichuxinxi/fenzhishezhi/list.vue')
      },
      {
        path: '/deyu/jichuxinxi/jifendengji',
        meta: { title: '积分等级', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/jichuxinxi/jifendengji/list.vue')
      },
      // 德育管理
      {
        path: '/deyu/deyuguanli/xinlijiankangjaoyu',
        meta: { title: '心理健康教育', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/deyuguanli/xinlijiankangjaoyu/list.vue')
      },
      {
        path: '/deyu/deyuguanli/anquanjiaoyu',
        meta: { title: '安全教育', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/deyuguanli/anquanjiaoyu/list.vue')
      },
      {
        path: '/deyu/deyuguanli/jiaxiaolianxijilu',
        meta: { title: '家校联系记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/deyuguanli/jiaxiaolianxijilu/list.vue')
      },
      {
        path: '/deyu/deyuguanli/gebiejiaoyujilu',
        meta: { title: '个别教育记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/deyuguanli/gebiejiaoyujilu/list.vue')
      },
      {
        path: '/deyu/deyuguanli/xueshengxuepipingyu',
        meta: { title: '学生学期评语', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/deyuguanli/xueshengxuepipingyu/list.vue')
      },
      {
        path: '/deyu/deyuguanli/xueshengzaixiaolvli',
        meta: { title: '学生在校履历', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/deyuguanli/xueshengzaixiaolvli/list.vue')
      },
      {
        path: '/deyu/deyuguanli/deyuhuodong',
        meta: { title: '德育活动', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/deyuguanli/deyuhuodong/list.vue')
      },
      {
        path: '/deyu/deyuguanli/shehuishijianhuodong',
        meta: { title: '社会实践活动', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/deyuguanli/shehuishijianhuodong/list.vue')
      },
      {
        path: '/deyu/deyuguanli/pingjiaguanli',
        meta: { title: '评价管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/deyuguanli/pingjiaguanli/list.vue')
      },
      {
        path: '/deyu/deyuguanli/xueshengpingjiahuizong',
        meta: { title: '学生评价汇总', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/deyuguanli/xueshengpingjiahuizong/list.vue')
      },
      {
        path: '/deyu/deyuguanli/deyufenhuizong',
        meta: { title: '德育分汇总', needLogin: true, keepAlive: true },
        component: () => import('@/pages/deyu/deyuguanli/deyufenhuizong/list.vue')
      },
      // 学生信息查询
      {
        path: '/deyu/xveshengxinxi/xueshengjibenxinxi',
        meta: { title: '学生基本信息', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/xveshengxinxi/xueshengjibenxinxi/list.vue')
      },
      {
        path: '/deyu/xveshengxinxi/xueshenglixiaoguanli',
        meta: { title: '学生离校管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/xveshengxinxi/xueshenglixiaoguanli/list.vue')
      },
      // 学生奖惩
      {
        path: '/deyu/xueshengjiangcheng/xueshengjiangli',
        meta: { title: '学生奖励', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/xueshengjiangcheng/xueshengjiangli/list.vue')
      },
      {
        path: '/deyu/xueshengjiangcheng/xueshengchengchu',
        meta: { title: '学生惩处', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/xueshengjiangcheng/xueshengchengchu/list.vue')
      },
      // 奖助贷管理
      {
        path: '/deyu/jiangzhudai/jiangxvejin',
        meta: { title: '奖学金管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/jiangzhudai/jiangxvejin/list.vue')
      },
      {
        path: '/deyu/jiangzhudai/zhuxvejin',
        meta: { title: '助学金管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/jiangzhudai/zhuxvejin/list.vue')
      },
      {
        path: '/deyu/jiangzhudai/zhuxuedaikuan',
        meta: { title: '助学贷款管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/jiangzhudai/zhuxuedaikuan/list.vue')
      },
      {
        path: '/deyu/jiangzhudai/linshikunnan',
        meta: { title: '临时困难补助', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuesheng/jiangzhudai/linshikunnan/list.vue')
      }
    ]
  },
  // 宿舍管理系统
  {
    path: '/sushe',
    meta: { keepAlive: true },
    redirect: '/sushe/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/sushe/home',
        meta: { title: '宿舍管理系统', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/sushehome.vue')
      },
      // 规章制度
      {
        path: '/sushe/guizhangzhidu/guizhangzhiduguanli',
        meta: { title: '规章制度管理', needLogin: true, keepAlive: true },
        component: () => import('@/components/guizhangzhidu/guizhangzhiduguanli/list.vue')
      },
      // 基础设置
      {
        path: '/sushe/jianzhuwu/jianzhuwu',
        meta: { title: '建筑物管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shebeizichan/jianzhuwu/jianzhuwu/list')
      },
      {
        path: '/sushe/jichuxinxi/susheguanli',
        meta: { title: '宿舍管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/jichuxinxi/susheguanli/list.vue')
      },
      {
        path: '/sushe/jichuxinxi/quyuguanli',
        meta: { title: '区域管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/jichuxinxi/quyuguanli/list.vue')
      },
      {
        path: '/sushe/jichuxinxi/pingyoujiangxiang',
        meta: { title: '评优奖项', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/jichuxinxi/pingyoujiangxiang/list.vue')
      },
      {
        path: '/sushe/jichuxinxi/pingyoudengji',
        meta: { title: '评优等级', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/jichuxinxi/pingyoudengji/list.vue')
      },
      {
        path: '/sushe/jichuxinxi/pingyouguanli',
        meta: { title: '评优管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/jichuxinxi/pingyouguanli/list.vue')
      },
      {
        path: '/sushe/jichuxinxi/pingyoulishichaxun',
        meta: { title: '评优历史查询', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/jichuxinxi/pingyoulishichaxun/list.vue')
      },
      {
        path: '/sushe/jichuxinxi/sushejianchaxiangmu',
        meta: { title: '宿舍检查项目', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/jichuxinxi/sushejianchaxiangmu/list.vue')
      },
      {
        path: '/sushe/jichuxinxi/chuangweibieming',
        meta: { title: '床位别名', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/jichuxinxi/chuangweibieming/list.vue')
      },
      {
        path: '/sushe/zhibanguanli/sushezhibanrili',
        meta: { title: '宿舍日历', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/zhibanguanli/sushezhibanrili/list.vue')
      },
      // 日常业务
      {
        path: '/sushe/richangyewu/sushefenpei',
        meta: { title: '宿舍分配', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/richangyewu/sushefenpei/list.vue')
      },
      {
        path: '/sushe/richangyewu/sushetiaohuan',
        meta: { title: '宿舍调换', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/richangyewu/sushetiaohuan/list.vue')
      },
      {
        path: '/sushe/richangyewu/zhususheng',
        meta: { title: '住宿生管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/richangyewu/zhususheng/list.vue')
      },
      {
        path: '/sushe/richangyewu/sushejiancha',
        meta: { title: '宿舍检查', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/richangyewu/sushejiancha/list.vue')
      },
      {
        path: '/sushe/richangyewu/ruzhutuisujilu',
        meta: { title: '入住退宿记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/richangyewu/ruzhutuisujilu/list.vue')
      },
      // 值班管理
      {
        path: '/sushe/zhibanguanli/banci',
        meta: { title: '班次', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/zhibanguanli/banci/list.vue')
      },
      {
        path: '/sushe/zhibanguanli/sushepaiban',
        meta: { title: '宿舍排班', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/zhibanguanli/sushepaiban/list.vue')
      },
      {
        path: '/sushe/zhibanguanli/sushezhibanbiao',
        meta: { title: '宿舍值班表', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/zhibanguanli/sushezhibanbiao/list.vue')
      },
      // 查寝
      {
        path: '/sushe/chaqin/chaqinjilu',
        meta: { title: '查寝记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/chaqin/chaqinjilu/list.vue')
      },
      {
        path: '/sushe/chaqin/chaqinyichangjilu',
        meta: { title: '查寝异常记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/chaqin/chaqinyichangjilu/list.vue')
      },
      // 人脸考勤
      {
        path: '/sushe/renliankaoqin/kaoqinshebeiguanli',
        meta: { title: '考勤设备管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/renliankaoqin/kaoqinshebeiguanli/list.vue')
      },
      {
        path: '/sushe/renliankaoqin/kaoqinshijiandian',
        meta: { title: '考勤时间点', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/renliankaoqin/kaoqinshijiandian/list.vue')
      },
      {
        path: '/sushe/renliankaoqin/zhusuxuesheng',
        meta: { title: '住宿学生', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/renliankaoqin/zhusuxuesheng/list.vue')
      },
      {
        path: '/sushe/renliankaoqin/sushexueshengzhuangtai',
        meta: { title: '当前宿舍学生状态', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/renliankaoqin/sushexueshengzhuangtai/list.vue')
      },
      {
        path: '/sushe/renliankaoqin/sushekaoqinchaxun',
        meta: { title: '宿舍考勤查询', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/renliankaoqin/sushekaoqinchaxun/list.vue')
      },
      {
        path: '/sushe/renliankaoqin/guisuguanli',
        meta: { title: '学生归宿管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/renliankaoqin/guisuguanli/list.vue')
      },
      {
        path: '/sushe/renliankaoqin/qingsuguanli',
        meta: { title: '学生清宿管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/renliankaoqin/qingsuguanli/list.vue')
      },
      {
        path: '/sushe/renliankaoqin/wailairenyuandengji',
        meta: { title: '外来人员登记', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/renliankaoqin/wailairenyuandengji/list.vue')
      },
      {
        path: '/sushe/renliankaoqin/kaoqintongbu',
        meta: { title: '考勤同步任务', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/renliankaoqin/kaoqintongbu/list.vue')
      },
      {
        path: '/sushe/renliankaoqin/chuansujilu',
        meta: { title: '非本楼学生出入记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/renliankaoqin/chuansujilu/list.vue')
      },
      {
        path: '/sushe/renliankaoqin/jiaozhigongchurujilu',
        meta: { title: '教职工宿舍出入记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/renliankaoqin/jiaozhigongchurujilu/list.vue')
      },
      {
        path: '/sushe/renliankaoqin/susheloudashujupingtai',
        meta: { title: '宿舍楼大数据平台', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/renliankaoqin/susheloudashujupingtai/list.vue')
      },
      {
        path: '/sushe/renliankaoqin/sushetongji',
        meta: { title: '宿舍统计', needLogin: true, keepAlive: true },
        component: () => import('@/pages/sushe/renliankaoqin/sushetongji/index.vue')
      }
    ]
  },
  // 实习就业管理系统
  {
    path: '/shixijiuye',
    meta: { keepAlive: true },
    redirect: '/shixijiuye/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/shixijiuye/home',
        meta: { title: '实习就业管理系统', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shixijiuye/shixijiuyehome.vue')
      },
      // 规章制度
      {
        path: '/shixijiuye/guizhangzhidu/guizhangzhiduguanli',
        meta: { title: '规章制度管理', needLogin: true, keepAlive: true },
        component: () => import('@/components/guizhangzhidu/guizhangzhiduguanli/list.vue')
      },
      // 实习前业务
      {
        path: '/shixijiuye/shixiqianyewu/qiyexinxi',
        meta: { title: '企业信息', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shixijiuye/shixiqianyewu/qiyexinxi/list.vue')
      },
      {
        path: '/shixijiuye/shixiqianyewu/shixijihua',
        meta: { title: '实习计划', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shixijiuye/shixiqianyewu/shixijihua/list.vue')
      },
      {
        path: '/shixijiuye/shixiqianyewu/fenpeishixisheng',
        meta: { title: '分配实习生', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shixijiuye/shixiqianyewu/fenpeishixisheng/list.vue')
      },
      {
        path: '/shixijiuye/shixiqianyewu/weifenpeishixisheng',
        meta: { title: '未分配实习生', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shixijiuye/shixiqianyewu/weifenpeishixisheng/list.vue')
      },
      {
        path: '/shixijiuye/shixiqianyewu/shenheshixishenqing',
        meta: { title: '审核实习申请', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shixijiuye/shixiqianyewu/shenheshixishenqing/list.vue')
      },
      {
        path: '/shixijiuye/shixiguocheng/shixijilu',
        meta: { title: '实习记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shixijiuye/shixiguocheng/shixijilu/list.vue')
      },
      {
        path: '/shixijiuye/shixiguocheng/shixikaoqinjilu',
        meta: { title: '实习考勤记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shixijiuye/shixiguocheng/shixikaoqinjilu/list.vue')
      },
      {
        path: '/shixijiuye/shixijieshu/shixizongjie',
        meta: { title: '实习总结', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shixijiuye/shixijieshu/shixizongjie/list.vue')
      },
      {
        path: '/shixijiuye/shixijieshu/shixibaogaojilu',
        meta: { title: '实习报告记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shixijiuye/shixijieshu/shixibaogaojilu/list.vue')
      },
      // 就业管理
      {
        path: '/shixijiuye/jiouye/jiouyejilu',
        meta: { title: '就业记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shixijiuye/jiouye/jiouyejilu/list.vue')
      },
      // 毕业去向管理
      {
        path: '/shixijiuye/biyequxiang/biyequxiangmuban',
        meta: { title: '毕业去向模板管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shixijiuye/biyequxiang/biyequxiangmuban/list.vue')
      },
      {
        path: '/shixijiuye/biyequxiang/biyequxiangjilu',
        meta: { title: '毕业去向记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shixijiuye/biyequxiang/biyequxiangjilu/list.vue')
      }
    ]
  },
  // 办公管理系统
  {
    path: '/bangong',
    meta: { keepAlive: true },
    redirect: '/bangong/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/bangong/home',
        meta: { title: '办公管理系统', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/bangonghome.vue')
      },
      // 规章制度
      {
        path: '/bangong/guizhangzhidu/guizhangzhiduguanli',
        meta: { title: '规章制度管理', needLogin: true, keepAlive: true },
        component: () => import('@/components/guizhangzhidu/guizhangzhiduguanli/list.vue')
      },
      // 审批管理 BEGIN
      {
        path: '/bangong/shenpi/biaodan',
        meta: { title: '表单管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/shenpi/biaodan/list.vue')
      },
      {
        path: '/bangong/shenpi/liuchengguanli',
        meta: { title: '流程管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/shenpi/liuchengguanli/list.vue')
      },
      // 审批管理 END
      // 日常办公 BEGIN
      {
        path: '/bangong/richangbangong/huiyi',
        meta: { title: '会议管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/richangbangong/huiyi/list.vue')
      },
      {
        path: '/bangong/richangbangong/yonyin',
        meta: { title: '用印管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/richangbangong/yonyin/list.vue')
      },
      {
        path: '/bangong/richangbangong/zhizhang',
        meta: { title: '制章管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/richangbangong/zhizhang/list.vue')
      },
      {
        path: '/bangong/richangbangong/tongzhigonggao',
        meta: { title: '通知公告', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/richangbangong/tongzhigonggao/list.vue')
      },
      {
        path: '/bangong/richangbangong/tongzhishenhe',
        meta: { title: '通知审核', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/richangbangong/tongzhishenhe/list.vue')
      },
      {
        path: '/bangong/richangbangong/ziliaofenlei',
        meta: { title: '资料分类', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/richangbangong/ziliaofenlei/list.vue')
      },
      {
        path: '/bangong/richangbangong/ziliaohuibian',
        meta: { title: '资料汇编', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/richangbangong/ziliaohuibian/list.vue')
      },
      {
        path: '/bangong/richangbangong/ziliaoshenhe',
        meta: { title: '资料审核', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/richangbangong/ziliaoshenhe/list.vue')
      },
      // 日常办公 END
      {
        path: '/bangong/qita/beiwanglu',
        meta: { title: '备忘录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/qita/beiwanglu/list.vue')
      },
      {
        path: '/bangong/qita/xiaoji',
        meta: { title: '小记', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/qita/xiaoji/list.vue')
      },
      // 公文流转 BEGIN
      {
        path: '/bangong/gongwenliuzhuan/shouwendengji',
        meta: { title: '收文登记', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/gongwenliuzhuan/shouwendengji/list.vue')
      },
      // 公文流转 END
      // 考勤管理 BEGIN
      {
        path: '/bangong/kaoqinguanli/kaoqinshebeiguanli',
        meta: { title: '考勤设备管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/kaoqinguanli/kaoqinshebeiguanli/list.vue')
      },
      {
        path: '/bangong/kaoqinguanli/kaoqinyonghuguanli',
        meta: { title: '考勤用户管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/kaoqinguanli/kaoqinyonghuguanli/list.vue')
      },
      {
        path: '/bangong/kaoqinguanli/zhuapaijilu',
        meta: { title: '抓拍记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/kaoqinguanli/zhuapaijilu/list.vue')
      },
      {
        path: '/bangong/kaoqinguanli/kaoqinjilu',
        meta: { title: '考勤记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/kaoqinguanli/kaoqinjilu/list.vue')
      },
      {
        path: '/bangong/kaoqinguanli/kaoqinshijiandian',
        meta: { title: '考勤时间点查询', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/kaoqinguanli/kaoqinshijiandian/list.vue')
      },
      {
        path: '/bangong/kaoqinguanli/kaoqinshujuchaxun',
        meta: { title: '考勤数据查询', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/kaoqinguanli/kaoqinshujuchaxun/list.vue')
      },
      {
        path: '/bangong/kaoqinguanli/kaoqinbumentongji',
        meta: { title: '考勤部门统计', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/kaoqinguanli/kaoqinbumentongji/list.vue')
      },
      {
        path: '/bangong/kaoqinguanli/kaoqinshujuhuizong',
        meta: { title: '考勤数据汇总', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/kaoqinguanli/kaoqinshujuhuizong/list.vue')
      },
      {
        path: '/bangong/kaoqinguanli/jiaozhigongqingjiajilu',
        meta: { title: '考勤数据汇总', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/kaoqinguanli/jiaozhigongqingjiajilu/list.vue')
      },
      {
        path: '/bangong/kaoqinguanli/kaoqinpiliangxiufu',
        meta: { title: '考勤批量修复', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/kaoqinguanli/kaoqinpiliangxiufu/list.vue')
      },
      // 考勤管理 END

      // 工作内容管理Begin
      {
        path: '/bangong/gongzuoneirongguanli/gongzuoleibie',
        meta: { title: '工作类别', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/gongzuoneirongguanli/gongzuoleibie/list.vue')
      },
      {
        path: '/bangong/gongzuoneirongguanli/gongzuoneirong',
        meta: { title: '工作内容', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/gongzuoneirongguanli/gongzuoneirong/list.vue')
      },
      {
        path: '/bangong/gongzuoneirongguanli/bumenrenyuangongzuorenwu',
        meta: { title: '部门人员工作任务', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/gongzuoneirongguanli/bumenrenyuangongzuorenwu/list.vue')
      },
      // 工作内容管理End

      // 值班管理 BEGIN
      {
        path: '/bangong/zhibanguanli/zhibanleibie',
        meta: { title: '值班类别', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhibanguanli/zhibanleibie/list.vue')
      },
      {
        path: '/bangong/zhibanguanli/zhibanfanwei',
        meta: { title: '值班范围', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhibanguanli/zhibanfanwei/list.vue')
      },
      {
        path: '/bangong/zhibanguanli/zhibanneirong',
        meta: { title: '值班内容', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhibanguanli/zhibanneirong/list.vue')
      },
      {
        path: '/bangong/zhibanguanli/zhibananpai',
        meta: { title: '值班安排', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhibanguanli/zhibananpai/list.vue')
      },
      {
        path: '/bangong/zhibanguanli/zhibanrenwu',
        meta: { title: '值班任务', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhibanguanli/zhibanrenwu/list.vue')
      },
      {
        path: '/bangong/zhibanguanli/zhibanbiao',
        meta: { title: '值班表', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhibanguanli/zhibanbiao/list.vue')
      },
      {
        path: '/bangong/zhibanguanli/zhibanrizhi',
        meta: { title: '值班日志', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhibanguanli/zhibanrizhi/list.vue')
      },
      {
        path: '/bangong/zhibanguanli/zhibanrizhimuban',
        meta: { title: '值班日志模板', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhibanguanli/zhibanrizhimuban/list.vue')
      },
      {
        path: '/bangong/zhibanguanli/wodezhiban',
        meta: { title: '我的值班', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhibanguanli/wodezhiban/list.vue')
      },
      {
        path: '/bangong/zhibanguanli/tiaobanshenhe',
        meta: { title: '调班审核', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhibanguanli/tiaobanshenhe/list.vue')
      },
      {
        path: '/bangong/zhibanguanli/chabanjilu',
        meta: { title: '查班记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhibanguanli/chabanjilu/list.vue')
      },
      {
        path: '/bangong/zhibanguanli/zhibantongji',
        meta: { title: '值班统计', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhibanguanli/zhibantongji/list.vue')
      },
      // 值班管理 END
      // 站点管理 BEGIN
      {
        path: '/bangong/zhandianguanli/zhandian',
        meta: { title: '站点管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhandianguanli/zhandian/list.vue')
      },
      {
        path: '/bangong/zhandianguanli/yeshou',
        meta: { title: '页首管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhandianguanli/yeshou/list.vue')
      },
      {
        path: '/bangong/zhandianguanli/yeweiguanli',
        meta: { title: '页尾管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhandianguanli/yeweiguanli/list.vue')
      },
      {
        path: '/bangong/zhandianguanli/yeweileixing',
        meta: { title: '页尾类型', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhandianguanli/yeweileixing/list.vue')
      },
      {
        path: '/bangong/zhandianguanli/banquan',
        meta: { title: '版权管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhandianguanli/banquan/list.vue')
      },
      {
        path: '/bangong/zhandianguanli/daohang',
        meta: { title: '导航管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhandianguanli/daohang/list.vue')
      },
      {
        path: '/bangong/zhandianguanli/lunbotu',
        meta: { title: '轮播图管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhandianguanli/lunbotu/list.vue')
      },
      {
        path: '/bangong/zhandianguanli/tuijianwei',
        meta: { title: '推荐位管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhandianguanli/tuijianwei/list.vue')
      },
      {
        path: '/bangong/zhandianguanli/wenzhangguanli',
        meta: { title: '文章管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhandianguanli/wenzhangguanli/list.vue')
      },
      {
        path: '/bangong/zhandianguanli/wenzhangfenlei',
        meta: { title: '文章分类管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhandianguanli/wenzhangfenlei/list.vue')
      },
      {
        path: '/bangong/zhandianguanli/jianjieneirong',
        meta: { title: '简介内容管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhandianguanli/jianjieneirong/list.vue')
      },
      {
        path: '/bangong/zhandianguanli/guanyuwomen',
        meta: { title: '关于我们', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhandianguanli/guanyuwomen/list.vue')
      },
      {
        path: '/bangong/zhandianguanli/gexiangyangshiguanli',
        meta: { title: '个项样式管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhandianguanli/gexiangyangshiguanli/list.vue')
      },
      {
        path: '/bangong/zhandianguanli/mokuaiyangshiguanli',
        meta: { title: '模块样式管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/zhandianguanli/mokuaiyangshiguanli/list.vue')
      },
      // 站点管理 END
      // 网盘管理 BEGIN
      {
        path: '/bangong/wangpanguanli/kongjianshezhi',
        meta: { title: '空间设置', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/wangpanguanli/kongjianshezhi/list.vue')
      },
      {
        path: '/bangong/wangpanguanli/xuexiaowangpan',
        meta: { title: '学校网盘', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/wangpanguanli/xuexiaowangpan/list.vue')
      },
      {
        path: '/bangong/wangpanguanli/wenjainhuizong',
        meta: { title: '文件汇总', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/wangpanguanli/wenjainhuizong/list.vue')
      },
      {
        path: '/bangong/wangpanguanli/ziliaoleibie',
        meta: { title: '资料类别', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/wangpanguanli/ziliaoleibie/list.vue')
      },
      {
        path: '/bangong/wangpanguanli/ziliaolaiyuan',
        meta: { title: '资料来源', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/wangpanguanli/ziliaolaiyuan/list.vue')
      },
      {
        path: '/bangong/wangpanguanli/ziliaohuibian',
        meta: { title: '资料汇编', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/wangpanguanli/ziliaohuibian/list.vue')
      }
      // 网盘管理 END
    ]
  },
  // 人力资源管理系统
  {
    path: '/renliziyuan',
    meta: { keepAlive: true },
    redirect: '/renliziyuan/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/renliziyuan/home',
        meta: { title: '人力资源管理系统', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renliziyuanhome.vue')
      },
      // 规章制度
      {
        path: '/renliziyuan/guizhangzhidu/guizhangzhiduguanli',
        meta: { title: '规章制度管理', needLogin: true, keepAlive: true },
        component: () => import('@/components/guizhangzhidu/guizhangzhiduguanli/list.vue')
      },
      // 人事管理 BEGIN
      {
        path: '/renliziyuan/renshiguanli/jiaozhigong',
        meta: { title: '教职工信息', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/jiaozhigong/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/dangzhengzhiwu',
        meta: { title: '党政职务', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/dangzhengzhiwu/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/dangtuanxinxi',
        meta: { title: '党团信息', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/dangtuanxinxi/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/shehuijianzhi',
        meta: { title: '社会兼职', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/shehuijianzhi/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/xueshutuantijianzhi',
        meta: { title: '学术团体兼职', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/xueshutuantijianzhi/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/jiaozhigongxuexijianli',
        meta: { title: '学习简历', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/jiaozhigongxuexijianli/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/jiaozhigonggongzuojianli',
        meta: { title: '工作简历', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/jiaozhigonggongzuojianli/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/xuelixuewei',
        meta: { title: '学历学位', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/xuelixuewei/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/zhuanyenengliyuzigezhengshu',
        meta: { title: '专业能力与资格证书', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/zhuanyenengliyuzigezhengshu/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/yuyannengli',
        meta: { title: '语言能力', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/yuyannengli/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/zhuanyejishuzhiwu',
        meta: { title: '专业技术职务', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/zhuanyejishuzhiwu/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/gangweizhengshu',
        meta: { title: '岗位证书', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/gangweizhengshu/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/gongrenjishudengjijizhiwu',
        meta: { title: '工人技术等级及职务', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/gongrenjishudengjijizhiwu/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/guoneijinxiuxuexi',
        meta: { title: '国内进修学习', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/guoneijinxiuxuexi/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/chuguojinxiuxuexi',
        meta: { title: '出国（境）进修学习', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/chuguojinxiuxuexi/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/jiangli',
        meta: { title: '奖励', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/jiangli/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/chengchu',
        meta: { title: '惩处', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/chengchu/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/zuzhikaocha',
        meta: { title: '组织考察', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/zuzhikaocha/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/waijijiaoshipinyong',
        meta: { title: '外籍教师聘用', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/waijijiaoshipinyong/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/shuangshixingjiaoshipinyong',
        meta: { title: '“双师型”教师聘用', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/shuangshixingjiaoshipinyong/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/jianzhijiaoshipinyong',
        meta: { title: '兼职教师聘用', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/jianzhijiaoshipinyong/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/jiaoxuekeyanchengguo',
        meta: { title: '教学科研成果', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/jiaoxuekeyanchengguo/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/fabiaolunwen',
        meta: { title: '发表论文', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/fabiaolunwen/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/zhuanzhujiaocaijiaocan',
        meta: { title: '专著、教材、教参', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/zhuanzhujiaocaijiaocan/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/zhuanlichengguo',
        meta: { title: '专利成果', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/zhuanlichengguo/list.vue')
      },
      {
        path: '/renliziyuan/renshiguanli/jiaoshihuaxiang',
        meta: { title: '教师画像', needLogin: true, keepAlive: true },
        component: () => import('@/pages/renliziyuan/renshiguanli/jiaoshihuaxiang/list.vue')
      }
      // 人事管理 END
      // 考勤管理 BEGIN
      // 考勤管理 END
    ]
  },
  // 财务管理系统
  {
    path: '/caiwu',
    meta: { keepAlive: true },
    redirect: '/caiwu/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/caiwu/home',
        meta: { title: '财务管理系统', needLogin: true, keepAlive: true },
        component: () => import('@/pages/caiwu/caiwuhome.vue')
      },
      // 规章制度
      {
        path: '/caiwu/guizhangzhidu/guizhangzhiduguanli',
        meta: { title: '规章制度管理', needLogin: true, keepAlive: true },
        component: () => import('@/components/guizhangzhidu/guizhangzhiduguanli/list.vue')
      },
      // 日常业务 BEGIN
      {
        path: '/caiwu/richangyewu/yusuan',
        meta: { title: '预算管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/caiwu/richangyewu/yusuan/list.vue')
      },
      {
        path: '/caiwu/richangyewu/zhichu',
        meta: { title: '支出管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/caiwu/richangyewu/zhichu/list.vue')
      },
      // 日常业务 END
      // 工资管理 BEGIN
      {
        path: '/caiwu/gongzi/gongzijizhun',
        meta: { title: '工资基准', needLogin: true, keepAlive: true },
        name: 'gongzijizhun',
        component: () => import('@/pages/caiwu/gongzi/gongzijizhun/list.vue')
      },
      {
        path: '/caiwu/gongzi/gongzibiao',
        meta: { title: '工资表', needLogin: true, keepAlive: true },
        name: 'gongzibiao',
        component: () => import('@/pages/caiwu/gongzi/gongzibiao/list.vue')
      },
      {
        path: '/caiwu/gongzi/gongzihuizong',
        meta: { title: '工资汇总', needLogin: true, keepAlive: true },
        name: 'gongzihuizong',
        component: () => import('@/pages/caiwu/gongzi/gongzihuizong/list.vue')
      },
      {
        path: '/caiwu/gongzi/gongzifafang',
        meta: { title: '工资发放', needLogin: true, keepAlive: true },
        name: 'gongzifafang',
        component: () => import('@/pages/caiwu/gongzi/gongzifafang/list.vue')
      },
      {
        path: '/caiwu/gongzi/gongzifafangjilu',
        meta: { title: '工资发放记录', needLogin: true, keepAlive: true },
        name: 'gongzifafangjilu',
        component: () => import('@/pages/caiwu/gongzi/gongzifafangjilu/list.vue')
      },
      {
        path: '/caiwu/gongzi/gongzixiangmu',
        name: 'gongzixiangmu',
        meta: { title: '工资项目', needLogin: true, keepAlive: true },
        component: () => import('@/pages/caiwu/gongzi/gongzixiangmu/list.vue')
      },
      // 工资管理 END
      // 学生缴费管理 BEGIN
      {
        path: '/caiwu/xueshengjiaofei/jiaofeixiang',
        meta: { title: '缴费项管理', needLogin: true, keepAlive: true },
        name: 'jiaofeixiang',
        component: () => import('@/pages/caiwu/xueshengjiaofei/jiaofeixiang/list.vue')
      },
      {
        path: '/caiwu/xueshengjiaofei/xueshengjiaofeijilu',
        meta: { title: '学生缴费记录', needLogin: true, keepAlive: true },
        name: 'xueshengjiaofeijilu',
        component: () => import('@/pages/caiwu/xueshengjiaofei/xueshengjiaofeijilu/list.vue')
      }
      // 学生缴费管理 END
    ]
  },
  // 设备资产管理系统
  {
    path: '/shebeizichan',
    meta: { keepAlive: true },
    redirect: '/shebeizichan/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/shebeizichan/home',
        meta: { title: '设备资产管理系统', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shebeizichan/shebeizichanhome.vue')
      },
      // 规章制度
      {
        path: '/shebeizichan/guizhangzhidu/guizhangzhiduguanli',
        meta: { title: '规章制度管理', needLogin: true, keepAlive: true },
        component: () => import('@/components/guizhangzhidu/guizhangzhiduguanli/list.vue')
      },
      // 基础设置
      {
        path: '/shebeizichan/jianzhuwu/jianzhuwu',
        meta: { title: '建筑物管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shebeizichan/jianzhuwu/jianzhuwu/list')
      },
      {
        path: '/shebeizichan/jianzhuwu/fangjian',
        meta: { title: '房间管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shebeizichan/jianzhuwu/fangjian/list')
      },
      {
        path: '/shebeizichan/wuxingzichan/zhuanli',
        meta: { title: '专利管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shebeizichan/wuxingzichan/zhuanli/list')
      },
      {
        path: '/shebeizichan/wuxingzichan/zhuzuoquan',
        meta: { title: '著作权管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shebeizichan/wuxingzichan/zhuzuoquan/list')
      },
      {
        path: '/shebeizichan/wuxingzichan/tudishiyonquan',
        meta: { title: '土地使用权管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shebeizichan/wuxingzichan/tudishiyonquan/list')
      },
      {
        path: '/shebeizichan/wuxingzichan/xinyu',
        meta: { title: '信誉管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shebeizichan/wuxingzichan/xinyu/list')
      },
      {
        path: '/shebeizichan/wuxingzichan/feizhuanlijishu',
        meta: { title: '非专利技术管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shebeizichan/wuxingzichan/feizhuanlijishu/list')
      },
      {
        path: '/shebeizichan/wuxingzichan/shangbiaoquan',
        meta: { title: '非专利技术管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shebeizichan/wuxingzichan/shangbiaoquan/list')
      },
      {
        path: '/shebeizichan/yiqishebei/yiqishebeijibenxinxi',
        meta: { title: '仪器设备', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shebeizichan/yiqishebei/yiqishebeijibenxinxi/list')
      },
      {
        path: '/shebeizichan/yiqishebei/yiqishebeishiyonxinxi',
        meta: { title: '仪器设备使用信息', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shebeizichan/yiqishebei/yiqishebeishiyonxinxi/list')
      },
      {
        path: '/shebeizichan/yiqishebei/yiqishebeibaosunbaofei',
        meta: { title: '仪器设备报废报损', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shebeizichan/yiqishebei/yiqishebeibaosunbaofei/list')
      }
    ]
  },
  // 远程培训管理平台
  {
    path: '/yuanchengpeixunguanli',
    meta: { keepAlive: true },
    redirect: '/yuanchengpeixunguanli/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/yuanchengpeixunguanli/home',
        meta: { title: '远程培训管理平台', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yuanchengpeixunguanli/yuanchengpeixunguanlihome.vue')
      },
      // 规章制度
      {
        path: '/yuanchengpeixunguanli/guizhangzhidu/guizhangzhiduguanli',
        meta: { title: '规章制度管理', needLogin: true, keepAlive: true },
        component: () => import('@/components/guizhangzhidu/guizhangzhiduguanli/list.vue')
      },
      // 基础设置
      {
        path: '/yuanchengpeixunguanli/jichuxinxi/banner',
        meta: { title: 'Banner图片管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yuanchengpeixunguanli/jichuxinxi/banner/list.vue')
      },
      {
        path: '/yuanchengpeixunguanli/jichuxinxi/zhuanyeguanli',
        meta: { title: '专业管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yuanchengpeixunguanli/jichuxinxi/zhuanyeguanli/list.vue')
      },
      {
        path: '/yuanchengpeixunguanli/jichuxinxi/banjiguanli',
        meta: { title: '班级管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yuanchengpeixunguanli/jichuxinxi/banjiguanli/list.vue')
      },
      {
        path: '/yuanchengpeixunguanli/jichuxinxi/kechengguanli',
        meta: { title: '课程管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yuanchengpeixunguanli/jichuxinxi/kechengguanli/list.vue')
      },
      {
        path: '/yuanchengpeixunguanli/jichuxinxi/peixunxuesheng',
        meta: { title: '远程培训学生管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yuanchengpeixunguanli/jichuxinxi/peixunxuesheng/list.vue')
      },
      {
        path: '/yuanchengpeixunguanli/jichuxinxi/zhuanyekecheng',
        meta: { title: '网络教学课程', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yuanchengpeixunguanli/jichuxinxi/zhuanyekecheng/list.vue')
      },
      // 网络课程
      {
        path: '/yuanchengpeixunguanli/wangluokecheng/wodewangluokecheng',
        meta: { title: '我的网络课程', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yuanchengpeixunguanli/wangluokecheng/wodewangluokecheng/list.vue')
      },
      {
        path: '/yuanchengpeixunguanli/wangluokecheng/gongxiangwangluokecheng',
        meta: { title: '共享网络课程', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yuanchengpeixunguanli/wangluokecheng/gongxiangwangluokecheng/list.vue')
      },
      {
        path: '/yuanchengpeixunguanli/wangluokecheng/wangluokechengshenhe',
        meta: { title: '网络课程审核', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yuanchengpeixunguanli/wangluokecheng/wangluokechengshenhe/list.vue')
      },
      // 资源库
      {
        path: '/yuanchengpeixunguanli/ziyuanku/shitiku',
        meta: { title: '试题库', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yuanchengpeixunguanli/ziyuanku/shitiku/list.vue')
      },
      {
        path: '/yuanchengpeixunguanli/ziyuanku/ziyuankushitishenhe',
        meta: { title: '试题库试题审核', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yuanchengpeixunguanli/ziyuanku/ziyuankushitishenhe/list.vue')
      }
    ]
  },
  // 校企共享信息平台
  {
    path: '/xiaoqigongxiang',
    meta: { keepAlive: true },
    redirect: '/xiaoqigongxiang/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/xiaoqigongxiang/home',
        meta: { title: '校企共享信息平台', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xiaoqigongxiang/xiaoqigongxianghome.vue')
      },
      // 基础信息
      {
        path: '/xiaoqigongxiang/jichuxinxi/qiyeyonghu',
        meta: { title: '企业用户', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xiaoqigongxiang/jichuxinxi/qiyeyonghu/list.vue')
      },
      // 校企合作
      {
        path: '/xiaoqigongxiang/xiaoqihezuo/hezuoxiangmu',
        meta: { title: '校企合作项目', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xiaoqigongxiang/xiaoqihezuo/hezuoxiangmu/list.vue')
      },
      {
        path: '/xiaoqigongxiang/xiaoqihezuo/hezuodongtai',
        meta: { title: '校企合作动态', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xiaoqigongxiang/xiaoqihezuo/hezuodongtai/list.vue')
      },
      {
        path: '/xiaoqigongxiang/xiaoqihezuo/hezuochengguo',
        meta: { title: '校企合作成果', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xiaoqigongxiang/xiaoqihezuo/hezuochengguo/list.vue')
      },
      // 共享资源库
      {
        path: '/xiaoqigongxiang/gongxiangziyuanku/gangweixinxi',
        meta: { title: '岗位信息', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xiaoqigongxiang/gongxiangziyuanku/gangweixinxi/list.vue')
      },
      {
        path: '/xiaoqigongxiang/gongxiangziyuanku/zhaopingangweixinxi',
        meta: { title: '招聘岗位信息', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xiaoqigongxiang/gongxiangziyuanku/zhaopingangweixinxi/list.vue')
      },
      {
        path: '/xiaoqigongxiang/gongxiangziyuanku/xueshengqiuzhiyixiang',
        meta: { title: '学生求职意向', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xiaoqigongxiang/gongxiangziyuanku/xueshengqiuzhiyixiang/list.vue')
      },
      // 职前辅导
      {
        path: '/xiaoqigongxiang/zhiqianfudao/xinxifabu',
        meta: { title: '信息发布', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xiaoqigongxiang/zhiqianfudao/xinxifabu/list.vue')
      },
      {
        path: '/xiaoqigongxiang/zhiqianfudao/yuyueguanli',
        meta: { title: '预约管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xiaoqigongxiang/zhiqianfudao/yuyueguanli/list.vue')
      },
      {
        path: '/xiaoqigongxiang/zhiqianfudao/yuyuejilu',
        meta: { title: '预约记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xiaoqigongxiang/zhiqianfudao/yuyuejilu/list.vue')
      },
      {
        path: '/xiaoqigongxiang/zhiqianfudao/yuyuedianming',
        meta: { title: '预约点名', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xiaoqigongxiang/zhiqianfudao/yuyuedianming/list.vue')
      },
      // 就业推荐管理
      {
        path: '/xiaoqigongxiang/jiuyetuijianguanli/tuijiandengji',
        meta: { title: '推荐登记', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xiaoqigongxiang/jiuyetuijianguanli/tuijiandengji/list.vue')
      },
      {
        path: '/xiaoqigongxiang/jiuyetuijianguanli/tuijianshenhe',
        meta: { title: '推荐审核', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xiaoqigongxiang/jiuyetuijianguanli/tuijianshenhe/list.vue')
      },
      {
        path: '/xiaoqigongxiang/jiuyetuijianguanli/tuijianfabu',
        meta: { title: '推荐发布', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xiaoqigongxiang/jiuyetuijianguanli/tuijianfabu/list.vue')
      },
      {
        path: '/xiaoqigongxiang/jiuyetuijianguanli/tuijanzhanshi',
        meta: { title: '推荐展示', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xiaoqigongxiang/jiuyetuijianguanli/tuijanzhanshi/list.vue')
      }
    ]
  },
  // 教科研管理系统
  {
    path: '/jiaokeyan',
    meta: { keepAlive: true },
    redirect: '/jiaokeyan/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/jiaokeyan/home',
        meta: { title: '教科研管理系统', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaokeyan/jiaokeyanhome.vue')
      },
      // 规章制度
      {
        path: '/jiaokeyan/guizhangzhidu/guizhangzhiduguanli',
        meta: { title: '规章制度管理', needLogin: true, keepAlive: true },
        component: () => import('@/components/guizhangzhidu/guizhangzhiduguanli/list.vue')
      },
      // 基础设置
      {
        path: '/jiaokeyan/jichuxinxi/ketijibie',
        meta: { title: '课题级别', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaokeyan/jichuxinxi/ketijibie/list.vue')
      },
      {
        path: '/jiaokeyan/jichuxinxi/jiaokeyanjibie',
        meta: { title: '教科研级别', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaokeyan/jichuxinxi/jiaokeyanjibie/list.vue')
      },
      {
        path: '/jiaokeyan/jichuxinxi/lunwenjibie',
        meta: { title: '论文级别', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaokeyan/jichuxinxi/lunwenjibie/list.vue')
      },
      {
        path: '/jiaokeyan/jichuxinxi/lunzhujibie',
        meta: { title: '论著级别', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaokeyan/jichuxinxi/lunzhujibie/list.vue')
      },
      {
        path: '/jiaokeyan/jichuxinxi/zhuanlijibie',
        meta: { title: '专利级别', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaokeyan/jichuxinxi/zhuanlijibie/list.vue')
      },
      {
        path: '/jiaokeyan/jichuxinxi/peixunjibie',
        meta: { title: '培训级别', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaokeyan/jichuxinxi/peixunjibie/list.vue')
      },
      {
        path: '/jiaokeyan/jichuxinxi/jianglijibie',
        meta: { title: '奖励级别', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaokeyan/jichuxinxi/jianglijibie/list.vue')
      },
      // 教师发展
      {
        path: '/jiaokeyan/jiaoshifazhan/ketiguanli',
        meta: { title: '课题管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaokeyan/jiaoshifazhan/ketiguanli/list.vue')
      },
      {
        path: '/jiaokeyan/jiaoshifazhan/jiaoxuekeyanchengguo',
        meta: { title: '教学科研成果', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaokeyan/jiaoshifazhan/jiaoxuekeyanchengguo/list.vue')
      },
      {
        path: '/jiaokeyan/jiaoshifazhan/fabiaolunwen',
        meta: { title: '发表论文', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaokeyan/jiaoshifazhan/fabiaolunwen/list.vue')
      },
      {
        path: '/jiaokeyan/jiaoshifazhan/zhuanzhujiaocaijiaocan',
        meta: { title: '专著、教材、教参', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaokeyan/jiaoshifazhan/zhuanzhujiaocaijiaocan/list.vue')
      },
      {
        path: '/jiaokeyan/jiaoshifazhan/zhuanlichengguo',
        meta: { title: '专利成果', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaokeyan/jiaoshifazhan/zhuanlichengguo/list.vue')
      },
      {
        path: '/jiaokeyan/jiaoshifazhan/peixun',
        meta: { title: '培训', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaokeyan/jiaoshifazhan/peixun/list.vue')
      },
      {
        path: '/jiaokeyan/jiaoshifazhan/jiangli',
        meta: { title: '奖励', needLogin: true, keepAlive: true },
        component: () => import('@/pages/jiaokeyan/jiaoshifazhan/jiangli/list.vue')
      }
    ]
  },
  // 学校后勤管理系统
  {
    path: '/xuexiaohouqin',
    meta: { keepAlive: true },
    redirect: '/xuexiaohouqin/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/xuexiaohouqin/home',
        meta: { title: '学校后勤管理系统', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuexiaohouqin/xuexiaohouqinhome.vue')
      },
      // 规章制度
      {
        path: '/xuexiaohouqin/guizhangzhidu/guizhangzhiduguanli',
        meta: { title: '规章制度管理', needLogin: true, keepAlive: true },
        component: () => import('@/components/guizhangzhidu/guizhangzhiduguanli/list.vue')
      },
      // 资产
      {
        path: '/xuexiaohouqin/zichan/baoxiuleibie',
        meta: { title: '报修类别', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuexiaohouqin/zichan/baoxiuleibie/list.vue')
      },
      {
        path: '/xuexiaohouqin/zichan/weixiurenyuan',
        meta: { title: '维修人员', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuexiaohouqin/zichan/weixiurenyuan/list.vue')
      },
      {
        path: '/xuexiaohouqin/zichan/zichanbaoxiu',
        meta: { title: '维修记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuexiaohouqin/zichan/zichanbaoxiu/list.vue')
      },
      // 物资发放
      {
        path: '/xuexiaohouqin/wuzifafang/wuzileibie',
        meta: { title: '物资类别', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuexiaohouqin/wuzifafang/wuzileibie/list.vue')
      },
      {
        path: '/xuexiaohouqin/wuzifafang/wuziguanli',
        meta: { title: '物资管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuexiaohouqin/wuzifafang/wuziguanli/list.vue')
      },
      {
        path: '/xuexiaohouqin/wuzifafang/fafangrenwu',
        meta: { title: '发放任务', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuexiaohouqin/wuzifafang/fafangrenwu/list.vue')
      },
      {
        path: '/xuexiaohouqin/wuzifafang/fafangjilu',
        meta: { title: '发放记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuexiaohouqin/wuzifafang/fafangjilu/list.vue')
      },
      // 能耗管理
      {
        path: '/xuexiaohouqin/nenghaoguanli/nengyuanguanli',
        meta: { title: '能源管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuexiaohouqin/nenghaoguanli/nengyuanguanli/list.vue')
      },
      {
        path: '/xuexiaohouqin/nenghaoguanli/nengyuanjihua',
        meta: { title: '能源计划', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuexiaohouqin/nenghaoguanli/nengyuanjihua/list.vue')
      },
      {
        path: '/xuexiaohouqin/nenghaoguanli/nengyuanshiyongjilu',
        meta: { title: '能源使用记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuexiaohouqin/nenghaoguanli/nengyuanshiyongjilu/list.vue')
      },
      {
        path: '/xuexiaohouqin/nenghaoguanli/nianduzongjie',
        meta: { title: '年度总结', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuexiaohouqin/nenghaoguanli/nianduzongjie/list.vue')
      },
      // 一卡通
      {
        path: '/xuexiaohouqin/yikatong/renzheng',
        meta: { title: '一卡通认证', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuexiaohouqin/yikatong/renzheng/list.vue')
      },
      // 餐饮管理
      {
        path: '/canyin/jichuxinxi/canyinzhidu',
        meta: { title: '餐饮制度', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/jichuxinxi/canyinzhidu/list.vue')
      },
      {
        path: '/canyin/jichuxinxi/yuancailiaoleibie',
        meta: { title: '原材料分类', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/jichuxinxi/yuancailiaoleibie/list.vue')
      },
      {
        path: '/canyin/jichuxinxi/yuancailiao',
        meta: { title: '原材料管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/jichuxinxi/yuancailiao/list.vue')
      },
      {
        path: '/canyin/jichuxinxi/yuancailiaocaigou',
        meta: { title: '原材料采购', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/jichuxinxi/yuancailiaocaigou/list.vue')
      },
      {
        path: '/canyin/jichuxinxi/canyinshijian',
        meta: { title: '餐饮时间管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/jichuxinxi/canyinshijian/list.vue')
      },
      {
        path: '/canyin/richangguanli/caipinleibie',
        meta: { title: '菜品分类', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/richangguanli/caipinleibie/list.vue')
      },
      {
        path: '/canyin/richangguanli/caipinguanli',
        meta: { title: '菜品管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/richangguanli/caipinguanli/list.vue')
      },
      {
        path: '/canyin/richangguanli/meiricaiyang',
        meta: { title: '每日菜样', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/richangguanli/meiricaiyang/list.vue')
      },
      {
        path: '/canyin/richangguanli/meiricaipin',
        meta: { title: '每日菜品', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/richangguanli/meiricaipin/list.vue')
      },
      {
        path: '/canyin/richangguanli/jiaozhigongdingdan',
        meta: { title: '教职工订单', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/richangguanli/jiaozhigongdingdan/list.vue')
      },
      {
        path: '/canyin/richangguanli/jiaozhigongdingcantongji',
        meta: { title: '教职工订餐统计', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/richangguanli/jiaozhigongdingcantongji/list.vue')
      },
      {
        path: '/canyin/richangguanli/canyinshoufei',
        meta: { title: '餐饮收费', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/richangguanli/canyinshoufei/list.vue')
      }
    ]
  },
  // 学校规章制度
  {
    path: '/xuexiaoguizhangzhidu',
    meta: { keepAlive: true },
    redirect: '/xuexiaoguizhangzhidu/home',
    component: layout,
    children: [
      // 首页
      {
        path: '/xuexiaoguizhangzhidu/home',
        meta: { title: '学校规章制度', needLogin: true, keepAlive: true },
        component: () => import('@/pages/xuexiaoguizhangzhidu/xuexiaoguizhangzhiduhome.vue')
      }
    ]
  },
  // 医疗管理系统
  {
    path: '/yiliao',
    meta: { keepAlive: true },
    redirect: '/yiliao/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/yiliao/home',
        meta: { title: '医疗管理系统', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yiliao/yiliaohome.vue')
      },
      // 规章制度
      {
        path: '/yiliao/guizhangzhidu/guizhangzhiduguanli',
        meta: { title: '规章制度管理', needLogin: true, keepAlive: true },
        component: () => import('@/components/guizhangzhidu/guizhangzhiduguanli/list.vue')
      },
      // 基础设置
      {
        path: '/yiliao/jichuxinxi/lxguanli',
        meta: { title: '类型管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yiliao/jichuxinxi/lxguanli/list.vue')
      },
      {
        path: '/yiliao/jichuxinxi/ksguanli',
        meta: { title: '科室管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yiliao/jichuxinxi/ksguanli/list.vue')
      },
      {
        path: '/yiliao/jichuxinxi/jbguanli',
        meta: { title: '疾病管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yiliao/jichuxinxi/jbguanli/list.vue')
      },
      {
        path: '/yiliao/yaopinxinxi/yaopinchuzhi',
        meta: { title: '药品处置', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yiliao/yaopinxinxi/yaopinchuzhi/list.vue')
      },
      {
        path: '/yiliao/yaopinxinxi/yaopinfenlei',
        meta: { title: '药品分类', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yiliao/yaopinxinxi/yaopinfenlei/list.vue')
      },
      {
        path: '/yiliao/yaopinxinxi/yaopinpandian',
        meta: { title: '药品盘点', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yiliao/yaopinxinxi/yaopinpandian/list.vue')
      },
      {
        path: '/yiliao/yaopinxinxi/yaopinxiaoshou',
        meta: { title: '药品销售', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yiliao/yaopinxinxi/yaopinxiaoshou/list.vue')
      },
      {
        path: '/yiliao/yaopinxinxi/yaopinguanli',
        meta: { title: '药品管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yiliao/yaopinxinxi/yaopinguanli/list.vue')
      },
      {
        path: '/yiliao/yaopinxinxi/yaopinruku',
        meta: { title: '药品入库', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yiliao/yaopinxinxi/yaopinruku/list.vue')
      },
      {
        path: '/yiliao/jiuzhenguanli/jiuzhenjilu',
        meta: { title: '就诊记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yiliao/jiuzhenguanli/jiuzhenjilu/list.vue')
      },
      {
        path: '/yiliao/jiuzhenguanli/jiuzhentongji',
        meta: { title: '就诊统计', needLogin: true, keepAlive: true },
        component: () => import('@/pages/yiliao/jiuzhenguanli/jiuzhentongji/list.vue')
      }
    ]
  },
  // 平安校园
  {
    path: '/pinganxiaoyuan',
    meta: { keepAlive: true },
    redirect: '/pinganxiaoyuan/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/pinganxiaoyuan/home',
        meta: { title: '平安校园', needLogin: true, keepAlive: true },
        component: () => import('@/pages/pinganxiaoyuan/pinganxiaoyuanhome.vue')
      },
      // 规章制度
      {
        path: '/pinganxiaoyuan/guizhangzhidu/guizhangzhiduguanli',
        meta: { title: '规章制度管理', needLogin: true, keepAlive: true },
        component: () => import('@/components/guizhangzhidu/guizhangzhiduguanli/list.vue')
      },
      // 培训资料
      {
        path: '/pinganxiaoyuan/peixunziliao/peixunziliao',
        meta: { title: '培训资料', needLogin: true, keepAlive: true },
        component: () => import('@/pages/pinganxiaoyuan/peixunziliao/peixunziliao/list.vue')
      },
      // 主题活动
      {
        path: '/pinganxiaoyuan/zhutihuodong/zhutihuodong',
        meta: { title: '主题活动', needLogin: true, keepAlive: true },
        component: () => import('@/pages/pinganxiaoyuan/zhutihuodong/zhutihuodong/list.vue')
      },
      // 应急预案
      {
        path: '/pinganxiaoyuan/yingjiyuan/yingjiyuan',
        meta: { title: '应急预案', needLogin: true, keepAlive: true },
        component: () => import('@/pages/pinganxiaoyuan/yingjiyuan/yingjiyuan/list.vue')
      },
      // 隐患处理
      {
        path: '/pinganxiaoyuan/yinhuanchuli/yinhuanchuli',
        meta: { title: '隐患处理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/pinganxiaoyuan/yinhuanchuli/yinhuanchuli/list.vue')
      },
      // 巡检管理
      {
        path: '/pinganxiaoyuan/xunjianguanli/xunjiancelue',
        meta: { title: '巡检策略', needLogin: true, keepAlive: true },
        component: () => import('@/pages/pinganxiaoyuan/xunjianguanli/xunjiancelue/list.vue')
      },
      {
        path: '/pinganxiaoyuan/xunjianguanli/xunjianjilu',
        meta: { title: '巡检记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/pinganxiaoyuan/xunjianguanli/xunjianjilu/list.vue')
      }
    ]
  },
  // 组织管理系统
  {
    path: '/zuzhi',
    meta: { keepAlive: true },
    redirect: '/zuzhi/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/zuzhi/home',
        meta: { title: '组织管理系统', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/zuzhihome.vue')
      },
      // 规章制度
      {
        path: '/zuzhi/guizhangzhidu/guizhangzhiduguanli',
        meta: { title: '规章制度管理', needLogin: true, keepAlive: true },
        component: () => import('@/components/guizhangzhidu/guizhangzhiduguanli/list.vue')
      },
      // 党组织管理
      {
        path: '/zuzhi/dangzuzhi/shiwuleixing',
        meta: { title: '党事务类型', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/dangzuzhi/shiwuleixing/list.vue')
      },
      {
        path: '/zuzhi/dangzuzhi/zuzhiguanli',
        meta: { title: '党组织管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/dangzuzhi/zuzhiguanli/list.vue')
      },
      {
        path: '/zuzhi/dangzuzhi/zhiwuguanli',
        meta: { title: '党职务管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/dangzuzhi/zhiwuguanli/list.vue')
      },
      {
        path: '/zuzhi/dangzuzhi/chengyuanguanli',
        meta: { title: '党成员管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/dangzuzhi/chengyuanguanli/list.vue')
      },
      {
        path: '/zuzhi/dangzuzhi/shiwuguanli',
        meta: { title: '党事务管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/dangzuzhi/shiwuguanli/list.vue')
      },
      {
        path: '/zuzhi/dangzuzhi/zhutidangri',
        meta: { title: '党员主题党日', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/dangzuzhi/zhutidangri/list.vue')
      },
      {
        path: '/zuzhi/dangzuzhi/dangyuanfazhan',
        meta: { title: '党员发展', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/dangzuzhi/dangyuanfazhan/list.vue')
      },
      {
        path: '/zuzhi/dangzuzhi/dangyuanganbuxuexi',
        meta: { title: '党员干部学习', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/dangzuzhi/dangyuanganbuxuexi/list.vue')
      },
      {
        path: '/zuzhi/dangzuzhi/dangke',
        meta: { title: '党课', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/dangzuzhi/dangke/list.vue')
      },
      {
        path: '/zuzhi/dangzuzhi/sanhui',
        meta: { title: '三会', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/dangzuzhi/sanhui/list.vue')
      },
      // 团组织管理
      {
        path: '/zuzhi/tuanzuzhi/shiwuleixing',
        meta: { title: '团事务类型', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/tuanzuzhi/shiwuleixing/list.vue')
      },
      {
        path: '/zuzhi/tuanzuzhi/tuanfeibiaozhun',
        meta: { title: '团费标准', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/tuanzuzhi/tuanfeibiaozhun/list.vue')
      },
      {
        path: '/zuzhi/tuanzuzhi/zuzhiguanli',
        meta: { title: '团组织管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/tuanzuzhi/zuzhiguanli/list.vue')
      },
      {
        path: '/zuzhi/tuanzuzhi/zhiwuguanli',
        meta: { title: '团职务管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/tuanzuzhi/zhiwuguanli/list.vue')
      },
      {
        path: '/zuzhi/tuanzuzhi/chengyuanguanli',
        meta: { title: '团成员管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/tuanzuzhi/chengyuanguanli/list.vue')
      },
      {
        path: '/zuzhi/tuanzuzhi/shiwuguanli',
        meta: { title: '团事务管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/tuanzuzhi/shiwuguanli/list.vue')
      },
      {
        path: '/zuzhi/tuanzuzhi/xiaozu',
        meta: { title: '团小组', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/tuanzuzhi/xiaozu/list.vue')
      },
      {
        path: '/zuzhi/tuanzuzhi/qingniandaxuexi',
        meta: { title: '青年大学习', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/tuanzuzhi/qingniandaxuexi/list.vue')
      },
      {
        path: '/zuzhi/tuanzuzhi/changguituanke',
        meta: { title: '常规团课', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/tuanzuzhi/changguituanke/list.vue')
      },
      {
        path: '/zuzhi/tuanzuzhi/tuanrihuodong',
        meta: { title: '团日活动', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/tuanzuzhi/tuanrihuodong/list.vue')
      },
      {
        path: '/zuzhi/tuanzuzhi/tuanfeiguanli',
        meta: { title: '团费管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/tuanzuzhi/tuanfeiguanli/list.vue')
      },
      // 工会组织管理
      {
        path: '/zuzhi/gonghuizuzhi/shiwuleixing',
        meta: { title: '工会事务类型', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/gonghuizuzhi/shiwuleixing/list.vue')
      },
      {
        path: '/zuzhi/gonghuizuzhi/zuzhiguanli',
        meta: { title: '工会组织管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/gonghuizuzhi/zuzhiguanli/list.vue')
      },
      {
        path: '/zuzhi/gonghuizuzhi/zhiwuguanli',
        meta: { title: '工会职务管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/gonghuizuzhi/zhiwuguanli/list.vue')
      },
      {
        path: '/zuzhi/gonghuizuzhi/chengyuanguanli',
        meta: { title: '工会成员管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/gonghuizuzhi/chengyuanguanli/list.vue')
      },
      {
        path: '/zuzhi/gonghuizuzhi/shiwuguanli',
        meta: { title: '工会事务管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/gonghuizuzhi/shiwuguanli/list.vue')
      },
      // 学生会组织管理
      {
        path: '/zuzhi/xueshenghuizuzhi/shiwuleixing',
        meta: { title: '学生会事务类型', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/xueshenghuizuzhi/shiwuleixing/list.vue')
      },
      {
        path: '/zuzhi/xueshenghuizuzhi/zuzhiguanli',
        meta: { title: '学生会组织管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/xueshenghuizuzhi/zuzhiguanli/list.vue')
      },
      {
        path: '/zuzhi/xueshenghuizuzhi/zhiwuguanli',
        meta: { title: '学生会职务管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/xueshenghuizuzhi/zhiwuguanli/list.vue')
      },
      {
        path: '/zuzhi/xueshenghuizuzhi/chengyuanguanli',
        meta: { title: '学生会成员管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/xueshenghuizuzhi/chengyuanguanli/list.vue')
      },
      {
        path: '/zuzhi/xueshenghuizuzhi/shiwuguanli',
        meta: { title: '学生会事务管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/xueshenghuizuzhi/shiwuguanli/list.vue')
      },
      // 社团组织管理
      {
        path: '/zuzhi/shetuanzuzhi/shiwuleixing',
        meta: { title: '社团事务类型', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/shetuanzuzhi/shiwuleixing/list.vue')
      },
      {
        path: '/zuzhi/shetuanzuzhi/zuzhiguanli',
        meta: { title: '社团组织管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/shetuanzuzhi/zuzhiguanli/list.vue')
      },
      {
        path: '/zuzhi/shetuanzuzhi/zhiwuguanli',
        meta: { title: '社团职务管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/shetuanzuzhi/zhiwuguanli/list.vue')
      },
      {
        path: '/zuzhi/shetuanzuzhi/chengyuanguanli',
        meta: { title: '社团成员管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/shetuanzuzhi/chengyuanguanli/list.vue')
      },
      {
        path: '/zuzhi/shetuanzuzhi/shiwuguanli',
        meta: { title: '社团事务管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/shetuanzuzhi/shiwuguanli/list.vue')
      },
      // 其他组织管理
      {
        path: '/zuzhi/qitazuzhi/shiwuleixing',
        meta: { title: '其他事务类型', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/qitazuzhi/shiwuleixing/list.vue')
      },
      {
        path: '/zuzhi/qitazuzhi/zuzhiguanli',
        meta: { title: '其他组织管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/qitazuzhi/zuzhiguanli/list.vue')
      },
      {
        path: '/zuzhi/qitazuzhi/zhiwuguanli',
        meta: { title: '其他职务管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/qitazuzhi/zhiwuguanli/list.vue')
      },
      {
        path: '/zuzhi/qitazuzhi/chengyuanguanli',
        meta: { title: '其他成员管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/qitazuzhi/chengyuanguanli/list.vue')
      },
      {
        path: '/zuzhi/qitazuzhi/shiwuguanli',
        meta: { title: '其他事务管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zuzhi/qitazuzhi/shiwuguanli/list.vue')
      }
    ]
  },
  // 数据管理中心
  {
    path: '/shujuguanli',
    meta: { keepAlive: true },
    redirect: '/shujuguanli/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/shujuguanli/home',
        meta: { title: '数据管理中心', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/shujuguanlihome.vue')
      },
      // 基础信息
      {
        path: '/shujuguanli/jichuxinxi/xuejimuban',
        meta: { title: '学籍模板', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/jichuxinxi/xuejimuban/list.vue')
      },
      {
        path: '/shujuguanli/jichuxinxi/zhaoshengmuban',
        meta: { title: '招生模板', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/jichuxinxi/zhaoshengmuban/list.vue')
      },
      // 公共数据
      {
        path: '/shujuguanli/gonggongshuju/zhiwu',
        meta: { title: '职务管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/gonggongshuju/zhiwu/list.vue')
      },
      {
        path: '/shujuguanli/gonggongshuju/xiaoqu',
        meta: { title: '校区管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/gonggongshuju/xiaoqu/list.vue')
      },
      {
        path: '/shujuguanli/gonggongshuju/jiaozhigong',
        meta: { title: '教职工管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/gonggongshuju/jiaozhigong/list.vue')
      },
      {
        path: '/shujuguanli/gonggongshuju/xveshengjibenxinxi',
        meta: { title: '学生基本信息', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/gonggongshuju/xveshengjibenxinxi/list.vue')
      },
      {
        path: '/shujuguanli/gonggongshuju/shouyelunbotu',
        meta: { title: '首页轮播', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/gonggongshuju/shouyelunbotu/list.vue')
      },
      {
        path: '/shujuguanli/gonggongshuju/xuexiaojibenxinxi',
        meta: { title: '学校基本信息', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/gonggongshuju/xuexiaojibenxinxi/list.vue')
      },
      {
        path: '/shujuguanli/gonggongshuju/xiaoneijigou',
        meta: { title: '校内机构', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/gonggongshuju/xiaoneijigou/list.vue')
      },
      {
        path: '/shujuguanli/gonggongshuju/zidian',
        meta: { title: '字典管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/gonggongshuju/zidian/list.vue')
      },
      {
        path: '/shujuguanli/gonggongshuju/xingzhengquhua',
        meta: { title: '行政区划', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/gonggongshuju/xingzhengquhua/list.vue')
      },
      {
        path: '/shujuguanli/gonggongshuju/dabiaoxuexiaohexinzhibiao',
        meta: { title: '达标学校核心指标', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/gonggongshuju/dabiaoxuexiaohexinzhibiao/list.vue')
      },
      {
        path: '/shujuguanli/gonggongshuju/caozuorizhi',
        meta: { title: '操作日志', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/gonggongshuju/caozuorizhi/list.vue')
      },
      {
        path: '/shujuguanli/gonggongshuju/shujukubeifen',
        meta: { title: '数据库备份', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/gonggongshuju/shujukubeifen/list.vue')
      },
      // 学校信息
      {
        path: '/shujuguanli/xuexiaoxinxi/zaixianshiwubanli',
        meta: { title: '在线事务办理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/xuexiaoxinxi/zaixianshiwubanli/list.vue')
      },
      {
        path: '/shujuguanli/xuexiaoxinxi/xiaoyuandongtai',
        meta: { title: '校园动态', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/xuexiaoxinxi/xiaoyuandongtai/list.vue')
      },
      {
        path: '/shujuguanli/xuexiaoxinxi/wangluoanquan',
        meta: { title: '网络安全管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/xuexiaoxinxi/wangluoanquan/list.vue')
      },
      {
        path: '/shujuguanli/xuexiaoxinxi/xiaobenshujuzhongxin',
        meta: { title: '校本数据中心', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/xuexiaoxinxi/xiaobenshujuzhongxin/list.vue')
      },
      {
        path: '/shujuguanli/xuexiaoxinxi/shujubiaozhun',
        meta: { title: '数据标准与信息系统映射关系', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/xuexiaoxinxi/shujubiaozhun/list.vue')
      },
      {
        path: '/shujuguanli/xuexiaoxinxi/xinxihuaxitongjicheng',
        meta: { title: '信息化系统集成情况', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/xuexiaoxinxi/xinxihuaxitongjicheng/list.vue')
      },
      // 其他
      {
        path: '/shujuguanli/richangbangong/tongzhigonggao',
        meta: { title: '通知公告', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/richangbangong/tongzhigonggao/list.vue')
      },
      {
        path: '/shujuguanli/wangpanguanli/ziliaohuibian',
        meta: { title: '资料汇编', needLogin: true, keepAlive: true },
        component: () => import('@/pages/gerenzhongxin/wangpanguanli/ziliaohuibian/list.vue')
      },
      {
        path: '/shujuguanli/richangbangong/tongzhishenhe',
        meta: { title: '通知审核', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/richangbangong/tongzhishenhe/list.vue')
      },
      // 系统信息
      {
        path: '/shujuguanli/gonggongshuju/yejiao',
        meta: { title: '页脚', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/gonggongshuju/yejiao/list.vue')
      },
      {
        path: '/shujuguanli/xitongxinxi/shezhi',
        meta: { title: '设置', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/xitongxinxi/shezhi/list.vue')
      },
      {
        path: '/shujuguanli/gonggongshuju/moudle',
        meta: { title: '模块管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/gonggongshuju/moudle/list.vue')
      },
      {
        path: '/shujuguanli/gonggongshuju/menu',
        meta: { title: '菜单管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/gonggongshuju/menu/list.vue')
      },
      {
        path: '/shujuguanli/xitongxinxi/appcandan',
        meta: { title: 'APP菜单', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/xitongxinxi/appcandan/list.vue')
      },
      {
        path: '/shujuguanli/xitongxinxi/xitongjieshao',
        meta: { title: '系统介绍', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/xitongxinxi/xitongjieshao/list.vue')
      },
      {
        path: '/shujuguanli/xitongxinxi/bangzhu',
        meta: { title: '帮助说明', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shujuguanli/xitongxinxi/bangzhu/list.vue')
      },
      // 审批管理 BEGIN
      {
        path: '/shujuguanli/shenpi/biaodan',
        meta: { title: '表单管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/shenpi/biaodan/list.vue')
      },
      {
        path: '/shujuguanli/shenpi/liuchengguanli',
        meta: { title: '流程管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/bangong/shenpi/liuchengguanli/list.vue')
      }
      // 审批管理 END
    ]
  },
  // 数字教学资源管理中心
  {
    path: '/shuzijiaoxue',
    meta: { keepAlive: true },
    redirect: '/shuzijiaoxue/home',
    component: ziLayout,
    children: [
      {
        path: '/shuzijiaoxue/home',
        meta: { title: '首页', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/shuzijiaoxuehome.vue')
      },
      // 资源库 BEGIN
      {
        path: '/shuzijiaoxue/ziyuanku/shitiku',
        meta: { title: '试题库', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/ziyuanku/shitiku/list.vue')
      },
      {
        path: '/shuzijiaoxue/ziyuanku/shijuanku',
        meta: { title: '试卷库', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/ziyuanku/shijuanku/list.vue')
      },
      {
        path: '/shuzijiaoxue/ziyuanku/shijuan',
        meta: { title: '试卷', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/ziyuanku/shijuan/list.vue')
      },
      {
        path: '/shuzijiaoxue/ziyuanku/ziyuankuguanli',
        meta: { title: '试题库', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/ziyuanku/ziyuankuguanli/list.vue')
      },
      {
        path: '/shuzijiaoxue/ziyuanku/ziyuankushitishenhe',
        meta: { title: '资源库试题审核', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/ziyuanku/ziyuankushitishenhe/list.vue')
      },
      {
        path: '/shuzijiaoxue/ziyuanku/ziyuankushijuanshenhe',
        meta: { title: '资源库试卷审核', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/ziyuanku/ziyuankushijuanshenhe/list.vue')
      },
      // 资源管理 BEGIN
      {
        path: '/shuzijiaoxue/ziyuanguanli/ziyuanguanli',
        meta: { title: '资源管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/ziyuanguanli/ziyuanguanli/list.vue')
      },
      {
        path: '/shuzijiaoxue/ziyuanguanli/ziyuanshenhe',
        meta: { title: '资源审核', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/ziyuanguanli/ziyuanshenhe/list.vue')
      },
      {
        path: '/shuzijiaoxue/ziyuanguanli/xiazairizhi',
        meta: { title: '资源审核', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/ziyuanguanli/xiazairizhi/list.vue')
      },
      {
        path: '/shuzijiaoxue/ziyuanguanli/ziyuanpinglun',
        meta: { title: '资源审核', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/ziyuanguanli/ziyuanpinglun/list.vue')
      },
      // 资源管理 END
      // 我的资源 BEGIN
      {
        path: '/shuzijiaoxue/wodeziyuan/wodeziyuan',
        meta: { title: '我的资源', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/wodeziyuan/wodeziyuan/list.vue')
      },
      {
        path: '/shuzijiaoxue/wodeziyuan/xiazairizhi',
        meta: { title: '下载日志', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/wodeziyuan/xiazairizhi/list.vue')
      },
      {
        path: '/shuzijiaoxue/wodeziyuan/ziyuanpinglun',
        meta: { title: '资源评论', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/wodeziyuan/ziyuanpinglun/list.vue')
      },
      {
        path: '/shuzijiaoxue/wodeziyuan/wodegongxiangjilu',
        meta: { title: '我的共享记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/wodeziyuan/wodegongxiangjilu/list.vue')
      },
      {
        path: '/shuzijiaoxue/wodeziyuan/wodeziyuantongji',
        meta: { title: '我的资源统计', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/wodeziyuan/wodeziyuantongji/list.vue')
      },
      // 我的资源 END
      // 共享资源 BEGIN
      {
        path: '/shuzijiaoxue/gongxiangziyuan/ziyuanleixing',
        meta: { title: '资源类型', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/gongxiangziyuan/ziyuanleixing/list.vue')
      },
      {
        path: '/shuzijiaoxue/gongxiangziyuan/ziyuankuziyuan',
        meta: { title: '资源库资源', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/gongxiangziyuan/ziyuankuziyuan/list.vue')
      },
      {
        path: '/shuzijiaoxue/gongxiangziyuan/zhuanyeziyuan',
        meta: { title: '专业资源', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/gongxiangziyuan/zhuanyeziyuan/list.vue')
      },
      {
        path: '/shuzijiaoxue/gongxiangziyuan/gongxiangziyuanchaxun',
        meta: { title: '共享资源查询', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/gongxiangziyuan/gongxiangziyuanchaxun/list.vue')
      },
      // 共享资源 END
      // 资源查询统计 BEGIN
      {
        path: '/shuzijiaoxue/ziyuanchaxuntongji/jiaozhigongziyuantongji',
        meta: { title: '教职工资源统计', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/ziyuanchaxuntongji/jiaozhigongziyuantongji/list.vue')
      },
      {
        path: '/shuzijiaoxue/ziyuanchaxuntongji/gongxiangziyuantongji',
        meta: { title: '共享资源统计', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/ziyuanchaxuntongji/gongxiangziyuantongji/list.vue')
      },
      {
        path: '/shuzijiaoxue/ziyuanchaxuntongji/ziyuanzonghechaxun',
        meta: { title: '资源综合查询', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/ziyuanchaxuntongji/ziyuanzonghechaxun/list.vue')
      },
      {
        path: '/shuzijiaoxue/ziyuanchaxuntongji/ziyuanxiazairizhi',
        meta: { title: '资源下载日志', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/ziyuanchaxuntongji/ziyuanxiazairizhi/list.vue')
      },
      {
        path: '/shuzijiaoxue/ziyuanchaxuntongji/ziyuanpinglunchaxun',
        meta: { title: '资源评论查询', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/ziyuanchaxuntongji/ziyuanpinglunchaxun/list.vue')
      },
      {
        path: '/shuzijiaoxue/ziyuanchaxuntongji/ziyuanshenhejilu',
        meta: { title: '资源审核记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/ziyuanchaxuntongji/ziyuanshenhejilu/list.vue')
      }
      // 资源查询统计 END
    ]
  },
  // 网络课程管理与共享
  {
    path: '/wangluokecheng',
    meta: { keepAlive: true },
    redirect: '/wangluokecheng/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/wangluokecheng/home',
        meta: { title: '网络课程管理与共享', needLogin: true, keepAlive: true },
        component: () => import('@/pages/wangluokecheng/wangluokechenghome.vue')
      },
      // 规章制度
      {
        path: '/wangluokecheng/guizhangzhidu/guizhangzhiduguanli',
        meta: { title: '规章制度管理', needLogin: true, keepAlive: true },
        component: () => import('@/components/guizhangzhidu/guizhangzhiduguanli/list.vue')
      },
      // 基础设置
      {
        path: '/wangluokecheng/jichuxinxi/zhuanyekecheng',
        meta: { title: '专业课程管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/wangluokecheng/jichuxinxi/zhuanyekecheng/list.vue')
      },
      {
        path: '/wangluokecheng/jichuxinxi/banner',
        meta: { title: 'Banner图片管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/wangluokecheng/jichuxinxi/banner/list.vue')
      },
      // 网络课程
      {
        path: '/wangluokecheng/wangluokecheng/wodewangluokecheng',
        meta: { title: '我的网络课程', needLogin: true, keepAlive: true },
        component: () => import('@/pages/wangluokecheng/wangluokecheng/wodewangluokecheng/list.vue')
      },
      {
        path: '/wangluokecheng/wangluokecheng/gongxiangwangluokecheng',
        meta: { title: '共享网络课程', needLogin: true, keepAlive: true },
        component: () => import('@/pages/wangluokecheng/wangluokecheng/gongxiangwangluokecheng/list.vue')
      },
      {
        path: '/wangluokecheng/wangluokecheng/wangluokechengshenhe',
        meta: { title: '网络课程审核', needLogin: true, keepAlive: true },
        component: () => import('@/pages/wangluokecheng/wangluokecheng/wangluokechengshenhe/list.vue')
      },
      {
        path: '/wangluokecheng/wangluokecheng/zaixianxuexijilu',
        meta: { title: '在线学习记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/wangluokecheng/wangluokecheng/zaixianxuexijilu/list.vue')
      },
      {
        path: '/wangluokecheng/wangluokecheng/wangluokechengjihua',
        meta: { title: '网络课程计划', needLogin: true, keepAlive: true },
        component: () => import('@/pages/wangluokecheng/wangluokecheng/wangluokechengjihua/list.vue')
      },
      {
        path: '/wangluokecheng/wangluokecheng/xuexirenwu',
        meta: { title: '网络课程学习任务', needLogin: true, keepAlive: true },
        component: () => import('@/pages/wangluokecheng/wangluokecheng/xuexirenwu/list.vue')
      },
      {
        path: '/wangluokecheng/wangluokecheng/xueshengxuexijilu',
        meta: { title: '学生学习记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/wangluokecheng/wangluokecheng/xueshengxuexijilu/list.vue')
      },
      {
        path: '/wangluokecheng/wangluokecheng/xueshengceshijilu',
        meta: { title: '学生测试记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/wangluokecheng/wangluokecheng/xueshengceshijilu/list.vue')
      },
      {
        path: '/wangluokecheng/wangluokecheng/xueshengkaoshijilu',
        meta: { title: '学生考试记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/wangluokecheng/wangluokecheng/xueshengkaoshijilu/list.vue')
      },
      {
        path: '/wangluokecheng/wangluokecheng/xueshengxuexichengji',
        meta: { title: '学生学习成绩', needLogin: true, keepAlive: true },
        component: () => import('@/pages/wangluokecheng/wangluokecheng/xueshengxuexichengji/list.vue')
      }
    ]
  },
  // 餐饮管理系统
  {
    path: '/canyin',
    meta: { keepAlive: true },
    redirect: '/canyin/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/canyin/home',
        meta: { title: '餐饮管理系统', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/canyinhome.vue')
      },
      // 规章制度
      {
        path: '/canyin/guizhangzhidu/guizhangzhiduguanli',
        meta: { title: '规章制度管理', needLogin: true, keepAlive: true },
        component: () => import('@/components/guizhangzhidu/guizhangzhiduguanli/list.vue')
      },
      // 基础设置
      {
        path: '/canyin/jichuxinxi/canyinzhidu',
        meta: { title: '餐饮制度', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/jichuxinxi/canyinzhidu/list.vue')
      },
      {
        path: '/canyin/jichuxinxi/yuancailiaoleibie',
        meta: { title: '原材料分类', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/jichuxinxi/yuancailiaoleibie/list.vue')
      },
      {
        path: '/canyin/jichuxinxi/yuancailiao',
        meta: { title: '原材料管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/jichuxinxi/yuancailiao/list.vue')
      },
      {
        path: '/canyin/jichuxinxi/yuancailiaocaigou',
        meta: { title: '原材料采购', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/jichuxinxi/yuancailiaocaigou/list.vue')
      },
      {
        path: '/canyin/jichuxinxi/canyinshijian',
        meta: { title: '餐饮时间管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/jichuxinxi/canyinshijian/list.vue')
      },
      {
        path: '/canyin/richangguanli/caipinleibie',
        meta: { title: '菜品分类', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/richangguanli/caipinleibie/list.vue')
      },
      {
        path: '/canyin/richangguanli/caipinguanli',
        meta: { title: '菜品管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/richangguanli/caipinguanli/list.vue')
      },
      {
        path: '/canyin/richangguanli/meiricaiyang',
        meta: { title: '每日菜样', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/richangguanli/meiricaiyang/list.vue')
      },
      {
        path: '/canyin/richangguanli/meiricaipin',
        meta: { title: '每日菜品', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/richangguanli/meiricaipin/list.vue')
      },
      {
        path: '/canyin/richangguanli/jiaozhigongdingdan',
        meta: { title: '教职工订单', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/richangguanli/jiaozhigongdingdan/list.vue')
      },
      {
        path: '/canyin/richangguanli/jiaozhigongdingcantongji',
        meta: { title: '教职工订餐统计', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/richangguanli/jiaozhigongdingcantongji/list.vue')
      },
      {
        path: '/canyin/richangguanli/canyinshoufei',
        meta: { title: '餐饮收费', needLogin: true, keepAlive: true },
        component: () => import('@/pages/canyin/richangguanli/canyinshoufei/list.vue')
      }
    ]
  },
  // 智能预警平台
  {
    path: '/zhinnegyujingpingtai',
    meta: { keepAlive: true },
    redirect: '/zhinnegyujingpingtai/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/zhinnegyujingpingtai/home',
        meta: { title: '智能预警平台', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zhinnegyujingpingtai/home.vue')
      },
      // 基础设置
      {
        path: '/zhinnegyujingpingtai/jichushezhi/zhaoshengyujingguize',
        meta: { title: '招生预警规则', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zhinnegyujingpingtai/jichushezhi/zhaoshengyujingguize/list.vue')
      },
      {
        path: '/zhinnegyujingpingtai/zhaoshengyujing',
        meta: { title: '招生预警', needLogin: true, keepAlive: true },
        component: () => import('@/pages/zhinnegyujingpingtai/zhaoshengyujing/list.vue')
      }
    ]
  },
  // 个人中心
  {
    path: '/gerenzhongxin',
    meta: { keepAlive: true },
    redirect: '/gerenzhongxin/home',
    component: ziLayout,
    children: [
      // 首页
      {
        path: '/gerenzhongxin/home',
        meta: { title: '个人中心', needLogin: true, keepAlive: true },
        component: () => import('@/pages/gerenzhongxin/gerenzhongxinhome.vue')
      },
      // 我的事务
      {
        path: '/gerenzhongxin/wodeshiwu/zuzhishiwu',
        meta: { title: '组织事务', needLogin: true, keepAlive: true },
        component: () => import('@/pages/gerenzhongxin/wodeshiwu/zuzhishiwu/list.vue')
      },
      {
        path: '/gerenzhongxin/wodeshiwu/zhibanrenwu',
        meta: { title: '值班任务', needLogin: true, keepAlive: true },
        component: () => import('@/pages/gerenzhongxin/wodeshiwu/zhibanrenwu/list.vue')
      },
      {
        path: '/gerenzhongxin/wodeshiwu/wodetingke',
        meta: { title: '我的听课', needLogin: true, keepAlive: true },
        component: () => import('@/pages/gerenzhongxin/wodeshiwu/wodetingke/list.vue')
      },
      {
        path: '/gerenzhongxin/wodeshiwu/beiwanglu',
        meta: { title: '备忘录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/gerenzhongxin/wodeshiwu/beiwanglu/list.vue')
      },
      {
        path: '/gerenzhongxin/wodeshiwu/wodexiaoji',
        meta: { title: '我的小记', needLogin: true, keepAlive: true },
        component: () => import('@/pages/gerenzhongxin/wodeshiwu/wodexiaoji/list.vue')
      },
      {
        path: '/gerenzhongxin/wodeshiwu/wodeweixiu',
        meta: { title: '我的维修', needLogin: true, keepAlive: true },
        component: () => import('@/pages/gerenzhongxin/wodeshiwu/wodeweixiu/list.vue')
      },
      // 我的查询
      {
        path: '/gerenzhongxin/wodechaxun/gonzichaxun',
        meta: { title: '工资查询', needLogin: true, keepAlive: true },
        component: () => import('@/pages/gerenzhongxin/wodechaxun/gonzichaxun/list.vue')
      },
      {
        path: '/gerenzhongxin/wodechaxun/kaoqinchaxun',
        meta: { title: '考勤查询', needLogin: true, keepAlive: true },
        component: () => import('@/pages/gerenzhongxin/wodechaxun/kaoqinchaxun/list.vue')
      },
      {
        path: '/gerenzhongxin/wodechaxun/tongzhichaxun',
        meta: { title: '通知查询', needLogin: true, keepAlive: true },
        component: () => import('@/pages/gerenzhongxin/wodechaxun/tongzhichaxun/list.vue')
      },
      {
        path: '/gerenzhongxin/wodechaxun/tingkejieguo',
        meta: { title: '听课结果', needLogin: true, keepAlive: true },
        component: () => import('@/pages/gerenzhongxin/wodechaxun/tingkejieguo/list.vue')
      },
      {
        path: '/gerenzhongxin/wodechaxun/jiuzhenjilu',
        meta: { title: '就诊记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/gerenzhongxin/wodechaxun/jiuzhenjilu/list.vue')
      },
      // 考勤管理
      {
        path: '/gerenzhongxin/kaoqnguanli/kaoqinchaxun',
        meta: { title: '考勤查询', needLogin: true, keepAlive: true },
        component: () => import('@/pages/gerenzhongxin/kaoqnguanli/kaoqinchaxun/list.vue')
      },
      {
        path: '/gerenzhongxin/kaoqnguanli/kaoqinxiufushenhe',
        meta: { title: '考勤修复审核', needLogin: true, keepAlive: true },
        component: () => import('@/pages/gerenzhongxin/kaoqnguanli/kaoqinxiufushenhe/list.vue')
      },
      {
        path: '/gerenzhongxin/kaoqnguanli/kaoqinxiufujilu',
        meta: { title: '考勤修复记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/gerenzhongxin/kaoqnguanli/kaoqinxiufujilu/list.vue')
      },
      // 资源管理
      {
        path: '/gerenzhongxin/ziyuanguanli/wodeziyuan',
        meta: { title: '我的资源', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/wodeziyuan/wodeziyuan/list.vue')
      },
      {
        path: '/gerenzhongxin/ziyuanguanli/xiazairizhi',
        meta: { title: '下载日志', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/wodeziyuan/xiazairizhi/list.vue')
      },
      {
        path: '/gerenzhongxin/ziyuanguanli/ziyuanpinglun',
        meta: { title: '资源评论', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/wodeziyuan/ziyuanpinglun/list.vue')
      },
      {
        path: '/gerenzhongxin/ziyuanguanli/wodegongxiangjilu',
        meta: { title: '我的共享记录', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/wodeziyuan/wodegongxiangjilu/list.vue')
      },
      {
        path: '/gerenzhongxin/ziyuanguanli/wodeziyuantongji',
        meta: { title: '我的资源统计', needLogin: true, keepAlive: true },
        component: () => import('@/pages/shuzijiaoxue/wodeziyuan/wodeziyuantongji/list.vue')
      },
      // 排考管理
      {
        path: '/gerenzhongxin/paikaoguanli/wodejiankao',
        meta: { title: '我的监考', needLogin: true, keepAlive: true },
        component: () => import('@/pages/gerenzhongxin/paikaoguanli/wodejiankao/list.vue')
      },
      // 网盘管理
      {
        path: '/gerenzhongxin/wangpanguanli/wodewangpan',
        meta: { title: '我的网盘', needLogin: true, keepAlive: true },
        component: () => import('@/components/home/changguishiwu/tongyong/wangpan/wodewangpan.vue')
      },
      {
        path: '/gerenzhongxin/wangpanguanli/bumenwangpan',
        meta: { title: '部门网盘', needLogin: true, keepAlive: true },
        component: () => import('@/components/home/changguishiwu/tongyong/wangpan/bumenwangpan.vue')
      },
      {
        path: '/gerenzhongxin/wangpanguanli/xuexiaowangpan',
        meta: { title: '学校网盘', needLogin: true, keepAlive: true },
        component: () => import('@/components/home/changguishiwu/tongyong/wangpan/xuexiaowangpan.vue')
      },
      {
        path: '/gerenzhongxin/wangpanguanli/ziliaohuibian',
        meta: { title: '资料汇编', needLogin: true, keepAlive: true },
        component: () => import('@/pages/gerenzhongxin/wangpanguanli/ziliaohuibian/list.vue')
      },
      // 校园安全
      {
        path: '/gerenzhongxin/xiaoyuananquan/peixunziliao',
        meta: { title: '培训资料', needLogin: true, keepAlive: true },
        component: () => import('@/pages/gerenzhongxin/xiaoyuananquan/peixunziliao/list.vue')
      },
      {
        path: '/gerenzhongxin/xiaoyuananquan/zhutihuodong',
        meta: { title: '主题活动', needLogin: true, keepAlive: true },
        component: () => import('@/pages/gerenzhongxin/xiaoyuananquan/zhutihuodong/list.vue')
      },
      {
        path: '/gerenzhongxin/xiaoyuananquan/yinhuanchuli',
        meta: { title: '隐患处理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/gerenzhongxin/xiaoyuananquan/yinhuanchuli/list.vue')
      },
      {
        path: '/gerenzhongxin/xiaoyuananquan/xunjianguanli',
        meta: { title: '巡检管理', needLogin: true, keepAlive: true },
        component: () => import('@/pages/gerenzhongxin/xiaoyuananquan/xunjianguanli/list.vue')
      }
    ]
  }

]
